<template>
  <div class="mt-3 infos_assur">
    <h3 class="ongoing_contracts mb-4 ml-1">
      Ongoing Contracts :
    </h3>
    <carousel
      :per-page="1"
      :navigate-to="someLocalProperty"
      paginationColor="#DAD8EB"
      paginationActiveColor="#483A9D"
      :mouse-drag="true"
    >
      <slide>
        <div
          class="annuel_contracts"
          :style="{
            'background-image': `url(${require('../../../../assets/images/info_bg.svg')})`,
          }"
        >
          <h4>Annuel Contract</h4>
          <div class="sub_contracts">
            N°113 687 681 00012
          </div>
          <div class="num_police">
            <h4 class="subtitle">N° police:</h4>
            <p>66457871</p>
          </div>

          <div class="validate_date">
            <h4 class="subtitle">Validation date:</h4>
            <div class="dates">
              <div class="start_date d-flex">
                <svg
                  width="16"
                  height="18"
                  viewBox="0 0 16 18"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M5 4.3125C4.6925 4.3125 4.4375 4.0575 4.4375 3.75V1.5C4.4375 1.1925 4.6925 0.9375 5 0.9375C5.3075 0.9375 5.5625 1.1925 5.5625 1.5V3.75C5.5625 4.0575 5.3075 4.3125 5 4.3125Z"
                    fill="#49CF48"
                  />
                  <path
                    d="M11 4.3125C10.6925 4.3125 10.4375 4.0575 10.4375 3.75V1.5C10.4375 1.1925 10.6925 0.9375 11 0.9375C11.3075 0.9375 11.5625 1.1925 11.5625 1.5V3.75C11.5625 4.0575 11.3075 4.3125 11 4.3125Z"
                    fill="#49CF48"
                  />
                  <path
                    d="M14.375 7.37988H1.625C1.3175 7.37988 1.0625 7.12488 1.0625 6.81738C1.0625 6.50988 1.3175 6.25488 1.625 6.25488H14.375C14.6825 6.25488 14.9375 6.50988 14.9375 6.81738C14.9375 7.12488 14.6825 7.37988 14.375 7.37988Z"
                    fill="#49CF48"
                  />
                  <path
                    d="M11 17.0625H5C2.2625 17.0625 0.6875 15.4875 0.6875 12.75V6.375C0.6875 3.6375 2.2625 2.0625 5 2.0625H11C13.7375 2.0625 15.3125 3.6375 15.3125 6.375V12.75C15.3125 15.4875 13.7375 17.0625 11 17.0625ZM5 3.1875C2.855 3.1875 1.8125 4.23 1.8125 6.375V12.75C1.8125 14.895 2.855 15.9375 5 15.9375H11C13.145 15.9375 14.1875 14.895 14.1875 12.75V6.375C14.1875 4.23 13.145 3.1875 11 3.1875H5Z"
                    fill="#49CF48"
                  />
                  <path
                    d="M5.375 10.875C5.2775 10.875 5.18 10.8525 5.09 10.815C5 10.7775 4.91751 10.725 4.84251 10.6575C4.77501 10.5825 4.72249 10.5 4.68499 10.41C4.64749 10.32 4.625 10.2225 4.625 10.125C4.625 9.93001 4.70751 9.73502 4.84251 9.59252C4.91751 9.52502 5 9.4725 5.09 9.435C5.225 9.375 5.37501 9.36 5.52501 9.39C5.57001 9.3975 5.615 9.4125 5.66 9.435C5.705 9.45 5.75 9.47252 5.795 9.50252C5.8325 9.53252 5.86999 9.56252 5.90749 9.59252C5.93749 9.63002 5.97499 9.66751 5.99749 9.70501C6.02749 9.75001 6.05001 9.79501 6.06501 9.84001C6.08751 9.885 6.10251 9.93 6.11001 9.975C6.11751 10.0275 6.125 10.0725 6.125 10.125C6.125 10.32 6.04249 10.515 5.90749 10.6575C5.76499 10.7925 5.57 10.875 5.375 10.875Z"
                    fill="#49CF48"
                  />
                  <path
                    d="M8 10.8751C7.805 10.8751 7.61001 10.7926 7.46751 10.6576C7.43751 10.6201 7.40751 10.5826 7.37751 10.5451C7.34751 10.5001 7.32499 10.4552 7.30999 10.4102C7.28749 10.3652 7.27249 10.3202 7.26499 10.2752C7.25749 10.2227 7.25 10.1776 7.25 10.1251C7.25 10.0276 7.27249 9.93015 7.30999 9.84015C7.34749 9.75015 7.40001 9.66766 7.46751 9.59266C7.67751 9.38266 8.015 9.31514 8.285 9.43514C8.3825 9.47264 8.45749 9.52516 8.53249 9.59266C8.66749 9.73516 8.75 9.93015 8.75 10.1251C8.75 10.1776 8.74251 10.2227 8.73501 10.2752C8.72751 10.3202 8.71251 10.3652 8.69001 10.4102C8.67501 10.4552 8.65249 10.5001 8.62249 10.5451C8.59249 10.5826 8.56249 10.6201 8.53249 10.6576C8.45749 10.7251 8.3825 10.7777 8.285 10.8152C8.195 10.8527 8.0975 10.8751 8 10.8751Z"
                    fill="#49CF48"
                  />
                  <path
                    d="M5.375 13.5001C5.2775 13.5001 5.18 13.4777 5.09 13.4402C5 13.4027 4.91751 13.3501 4.84251 13.2826C4.77501 13.2076 4.72249 13.1327 4.68499 13.0352C4.64749 12.9452 4.625 12.8476 4.625 12.7501C4.625 12.5551 4.70751 12.3602 4.84251 12.2177C4.91751 12.1502 5 12.0976 5.09 12.0601C5.3675 11.9401 5.69749 12.0077 5.90749 12.2177C5.93749 12.2552 5.97499 12.2927 5.99749 12.3302C6.02749 12.3752 6.05001 12.4201 6.06501 12.4651C6.08751 12.5101 6.10251 12.5551 6.11001 12.6076C6.11751 12.6526 6.125 12.7051 6.125 12.7501C6.125 12.9451 6.04249 13.1401 5.90749 13.2826C5.76499 13.4176 5.57 13.5001 5.375 13.5001Z"
                    fill="#49CF48"
                  />
                </svg>
                <span>01/01/2023</span>
              </div>
              <div class="end_date d-flex">
                <svg
                  width="16"
                  height="18"
                  viewBox="0 0 16 18"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M5 4.3125C4.6925 4.3125 4.4375 4.0575 4.4375 3.75V1.5C4.4375 1.1925 4.6925 0.9375 5 0.9375C5.3075 0.9375 5.5625 1.1925 5.5625 1.5V3.75C5.5625 4.0575 5.3075 4.3125 5 4.3125Z"
                    fill="#FA3559"
                  />
                  <path
                    d="M11 4.3125C10.6925 4.3125 10.4375 4.0575 10.4375 3.75V1.5C10.4375 1.1925 10.6925 0.9375 11 0.9375C11.3075 0.9375 11.5625 1.1925 11.5625 1.5V3.75C11.5625 4.0575 11.3075 4.3125 11 4.3125Z"
                    fill="#FA3559"
                  />
                  <path
                    d="M14.375 7.37988H1.625C1.3175 7.37988 1.0625 7.12488 1.0625 6.81738C1.0625 6.50988 1.3175 6.25488 1.625 6.25488H14.375C14.6825 6.25488 14.9375 6.50988 14.9375 6.81738C14.9375 7.12488 14.6825 7.37988 14.375 7.37988Z"
                    fill="#FA3559"
                  />
                  <path
                    d="M11 17.0625H5C2.2625 17.0625 0.6875 15.4875 0.6875 12.75V6.375C0.6875 3.6375 2.2625 2.0625 5 2.0625H11C13.7375 2.0625 15.3125 3.6375 15.3125 6.375V12.75C15.3125 15.4875 13.7375 17.0625 11 17.0625ZM5 3.1875C2.855 3.1875 1.8125 4.23 1.8125 6.375V12.75C1.8125 14.895 2.855 15.9375 5 15.9375H11C13.145 15.9375 14.1875 14.895 14.1875 12.75V6.375C14.1875 4.23 13.145 3.1875 11 3.1875H5Z"
                    fill="#FA3559"
                  />
                  <path
                    d="M5.375 10.875C5.2775 10.875 5.18 10.8525 5.09 10.815C5 10.7775 4.91751 10.725 4.84251 10.6575C4.77501 10.5825 4.72249 10.5 4.68499 10.41C4.64749 10.32 4.625 10.2225 4.625 10.125C4.625 9.93001 4.70751 9.73502 4.84251 9.59252C4.91751 9.52502 5 9.4725 5.09 9.435C5.225 9.375 5.37501 9.36 5.52501 9.39C5.57001 9.3975 5.615 9.4125 5.66 9.435C5.705 9.45 5.75 9.47252 5.795 9.50252C5.8325 9.53252 5.86999 9.56252 5.90749 9.59252C5.93749 9.63002 5.97499 9.66751 5.99749 9.70501C6.02749 9.75001 6.05001 9.79501 6.06501 9.84001C6.08751 9.885 6.10251 9.93 6.11001 9.975C6.11751 10.0275 6.125 10.0725 6.125 10.125C6.125 10.32 6.04249 10.515 5.90749 10.6575C5.76499 10.7925 5.57 10.875 5.375 10.875Z"
                    fill="#FA3559"
                  />
                  <path
                    d="M8 10.8751C7.805 10.8751 7.61001 10.7926 7.46751 10.6576C7.43751 10.6201 7.40751 10.5826 7.37751 10.5451C7.34751 10.5001 7.32499 10.4552 7.30999 10.4102C7.28749 10.3652 7.27249 10.3202 7.26499 10.2752C7.25749 10.2227 7.25 10.1776 7.25 10.1251C7.25 10.0276 7.27249 9.93015 7.30999 9.84015C7.34749 9.75015 7.40001 9.66766 7.46751 9.59266C7.67751 9.38266 8.015 9.31514 8.285 9.43514C8.3825 9.47264 8.45749 9.52516 8.53249 9.59266C8.66749 9.73516 8.75 9.93015 8.75 10.1251C8.75 10.1776 8.74251 10.2227 8.73501 10.2752C8.72751 10.3202 8.71251 10.3652 8.69001 10.4102C8.67501 10.4552 8.65249 10.5001 8.62249 10.5451C8.59249 10.5826 8.56249 10.6201 8.53249 10.6576C8.45749 10.7251 8.3825 10.7777 8.285 10.8152C8.195 10.8527 8.0975 10.8751 8 10.8751Z"
                    fill="#FA3559"
                  />
                  <path
                    d="M5.375 13.5001C5.2775 13.5001 5.18 13.4777 5.09 13.4402C5 13.4027 4.91751 13.3501 4.84251 13.2826C4.77501 13.2076 4.72249 13.1327 4.68499 13.0352C4.64749 12.9452 4.625 12.8476 4.625 12.7501C4.625 12.5551 4.70751 12.3602 4.84251 12.2177C4.91751 12.1502 5 12.0976 5.09 12.0601C5.3675 11.9401 5.69749 12.0077 5.90749 12.2177C5.93749 12.2552 5.97499 12.2927 5.99749 12.3302C6.02749 12.3752 6.05001 12.4201 6.06501 12.4651C6.08751 12.5101 6.10251 12.5551 6.11001 12.6076C6.11751 12.6526 6.125 12.7051 6.125 12.7501C6.125 12.9451 6.04249 13.1401 5.90749 13.2826C5.76499 13.4176 5.57 13.5001 5.375 13.5001Z"
                    fill="#FA3559"
                  />
                </svg>
                <span>31/12/2023</span>
              </div>
            </div>
          </div>

          <div class="car_identification">
            <h4 class="subtitle">
              Car identification
            </h4>
            <div class="car d-flex">
              <h5 class="subtitle_info">Brand</h5>
              <p class="info_insurance">Renault</p>
            </div>
            <div class="car d-flex">
              <h5 class="subtitle_info">Type</h5>
              <p class="info_insurance">05</p>
            </div>
            <div class="car d-flex">
              <h5 class="subtitle_info">Fiscal Power</h5>
              <p class="info_insurance">4</p>
            </div>
            <div class="car d-flex">
              <h5 class="subtitle_info">Car age</h5>
              <p class="info_insurance">8</p>
            </div>
            <div class="car d-flex">
              <h5 class="subtitle_info">Immatriculation N°</h5>
              <p class="info_insurance">8754 TU 108</p>
            </div>
            <div class="coverage d-flex mt-2">
              <h5 class="subtitle_info">Coverage per vehicle</h5>
              <p class="success_insurance">5.000 €</p>
            </div>
            <div class="prime d-flex">
              <h5 class="subtitle_info">Prime</h5>
              <p class="success_insurance">7,50 €</p>
            </div>
            <div class="asssured_risks">
              <h5 class="subtitle_info">Assured risks</h5>
              <ul class="ml-5">
                <li>
                  Body
                </li>
                <li>
                  carrosserie
                </li>
                <li>
                  tires
                </li>
                <li>
                  windshields and windows
                </li>
                <li>
                  exterior accessories
                </li>
              </ul>
            </div>
            <div class="signature_insurance">
              <h5 class="subtitle_info">Signature insurer:</h5>
              <svg
                width="79"
                height="67"
                viewBox="0 0 79 67"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M78.8531 8.67458C78.8514 8.62697 78.833 8.5815 78.8012 8.54622C78.7694 8.51093 78.7262 8.4881 78.6793 8.48175C78.6324 8.47539 78.5848 8.48593 78.5449 8.51151C78.5049 8.53708 78.4753 8.57603 78.4611 8.62149C75.6666 15.5109 73.3089 22.5718 71.4021 29.7617C68.6916 32.0858 65.2574 33.4594 61.6777 32.305C61.6438 32.2949 61.6078 32.2943 61.5736 32.3034C61.5394 32.3125 61.5084 32.3308 61.4838 32.3564C59.9657 34.326 57.3454 35.0967 55.0448 34.4193C55.3459 33.9048 55.5548 33.341 55.6623 32.7538C55.6703 32.7238 55.6715 32.6924 55.6656 32.6619C55.6598 32.6315 55.6471 32.6028 55.6285 32.578C55.61 32.5532 55.5861 32.533 55.5586 32.519C55.5312 32.5049 55.5009 32.4973 55.4701 32.4969C54.4971 32.4677 53.707 32.925 53.2376 33.7813C53.2118 33.8276 53.2049 33.882 53.2182 33.9333C53.2315 33.9846 53.2641 34.0286 53.309 34.0562C53.6613 34.288 54.0367 34.482 54.4291 34.6351C53.4196 36.0489 51.7076 36.9421 49.9216 36.6766C47.4016 36.3007 45.6692 33.7445 45.9549 31.2595C45.9796 31.0522 45.6768 31.0026 45.5833 31.1576C44.6294 32.7745 43.3557 34.1768 41.8412 35.2774C41.5894 33.7725 41.338 32.2682 41.0868 30.7645C41.0519 30.5564 40.7568 30.5932 40.7015 30.7645C38.9216 36.3173 35.4207 41.1494 30.7126 44.5514C31.4444 38.9638 32.5373 33.4301 33.9844 27.9857C36.8846 26.1874 39.385 23.6467 40.579 20.3995C42.0886 16.2976 40.9983 11.861 38.8296 8.22159C37.6399 6.25306 36.1896 4.45682 34.5185 2.88236C33.0931 1.52508 31.4032 0.142104 29.3595 0.0102293C25.927 -0.207279 23.8688 3.08531 22.8491 5.93861C22.0888 8.06488 21.7945 10.3059 21.479 12.5324C21.0997 15.211 20.7901 17.899 20.5137 20.5904C20.1114 24.5056 19.7797 28.4276 19.4081 32.3453C18.9137 32.4498 18.4218 32.5557 17.9325 32.663L0.143014 36.5858C-0.0321843 36.6244 -0.044091 36.8667 0.0945371 36.9532C5.68303 40.4556 11.7461 42.7762 17.9546 44.7347C17.6731 46.6032 17.3533 48.4657 16.9748 50.3145C15.4678 52.6706 13.9607 55.0272 12.4537 57.3844C11.3923 59.0457 10.3164 60.7001 9.27036 62.3717C8.40967 63.7469 7.67316 65.1513 7.55494 66.7989C7.55509 66.83 7.56238 66.8607 7.57625 66.8885C7.59012 66.9164 7.61018 66.9406 7.63488 66.9593C7.65958 66.9781 7.68824 66.9908 7.71863 66.9965C7.74902 67.0023 7.78032 67.0009 7.81008 66.9924C11.235 65.6583 13.413 62.6431 14.8197 59.342C16.0223 56.5161 16.7758 53.4881 17.3635 50.4447L18.2837 49.0026L20.5103 45.5182C27.7853 47.6967 35.2023 49.5258 42.2511 52.2832C46.3189 53.8743 50.2532 55.801 53.8975 58.2262C54.1127 58.3692 54.3126 58.0215 54.0991 57.8794C44.0158 51.17 32.1933 48.5873 20.7348 45.1663C23.6831 40.5541 26.6289 35.9422 29.5721 31.3305C29.9203 30.7859 30.2678 30.2416 30.6148 29.6975C31.0937 29.498 31.5682 29.2899 32.036 29.0638C32.5318 28.8241 33.0217 28.562 33.5031 28.282C32.0614 33.7745 30.9778 39.3559 30.2593 44.9907C30.2398 45.1397 30.4439 45.2476 30.5595 45.162C35.3098 41.8469 38.9043 37.1115 40.8342 31.626C41.061 32.9784 41.2878 34.3305 41.5146 35.6824C41.5228 35.7121 41.5376 35.7395 41.558 35.7625C41.5783 35.7855 41.6036 35.8034 41.632 35.815C41.6603 35.8266 41.6909 35.8315 41.7215 35.8293C41.752 35.8271 41.7816 35.8178 41.808 35.8023C43.2796 34.7811 44.5452 33.4876 45.5373 31.9908C45.6139 34.4159 47.4203 36.7177 49.8748 37.0799C51.8309 37.3685 53.7419 36.3581 54.828 34.773C55.6578 35.0304 56.5301 35.1195 57.3944 35.035C58.2587 34.9504 59.0977 34.694 59.8628 34.2806C60.3766 34.0044 60.8473 33.6538 61.2601 33.2401C61.5204 32.9764 61.5961 32.7871 61.9967 32.8223C62.3632 32.8557 62.7468 33.0072 63.1159 33.0603C64.3016 33.2245 65.5078 33.1488 66.6641 32.8377C68.3548 32.3915 69.8695 31.578 71.209 30.517C69.7627 36.07 68.5899 41.687 67.6906 47.3679C67.1106 51.0267 66.6476 54.7035 66.3018 58.3983C66.2771 58.6552 66.6768 58.6552 66.7007 58.3983C67.6048 48.8353 69.2876 39.3633 71.7321 30.0777C74.5957 27.5849 76.5892 23.9481 77.6803 20.4294C78.8477 16.6295 79.2465 12.6324 78.8531 8.67458ZM21.5224 15.2529C22.0369 11.1545 22.3303 6.4584 24.7814 2.96543C25.8521 1.43945 27.4332 0.285112 29.3655 0.415274C31.8021 0.580546 33.799 2.62461 35.3767 4.31672C38.4707 7.63329 41.0323 12.0151 40.8963 16.7035C40.7636 21.2575 37.8167 25.0339 34.1409 27.4231C34.692 25.3862 35.2913 23.3621 35.9388 21.3508C36.0111 21.1273 35.693 21.0083 35.574 21.1959L30.335 29.3927C26.9875 30.7713 23.3568 31.5155 19.818 32.2622C20.3632 26.5907 20.8131 20.9073 21.5224 15.2529ZM12.0948 42.313C8.15283 40.8367 4.32227 39.0692 0.728994 36.8676L17.0735 33.271C17.8338 33.0997 18.6044 32.9421 19.3698 32.7812C19.2326 34.2015 19.0872 35.6216 18.9335 37.0414C18.6673 39.4691 18.3713 41.9071 18.0141 44.3356C16.0257 43.7054 14.0441 43.0417 12.0948 42.3121V42.313ZM15.848 55.0826C14.6301 59.5715 12.5124 64.5407 7.99804 66.4718C8.20385 64.8653 9.03988 63.4798 9.89801 62.1293C10.8279 60.6696 11.7597 59.2109 12.6935 57.7535L16.7316 51.432C16.4637 52.6566 16.1754 53.8743 15.848 55.0826ZM17.5566 49.394C17.7505 48.3278 17.9291 47.2617 18.1026 46.205C18.1766 45.7537 18.2455 45.3007 18.3152 44.8486C18.9122 45.0341 19.5101 45.2174 20.1089 45.3983L17.5566 49.394ZM20.3334 45.0472C19.6802 44.8514 19.0282 44.6516 18.3773 44.4478C18.9667 40.5438 19.3979 36.6209 19.7738 32.6921C23.2174 31.9711 26.7018 31.2321 29.971 29.9518L20.3334 45.0472ZM30.9814 29.1195L35.1096 22.6568C34.5863 24.3403 34.097 26.033 33.6417 27.7348C32.7865 28.2531 31.899 28.7153 30.9848 29.1186L30.9814 29.1195ZM53.6892 33.8147C53.8544 33.5521 54.0795 33.333 54.3458 33.1756C54.6121 33.0182 54.9118 32.927 55.22 32.9096C55.1048 33.3944 54.9163 33.8585 54.6613 34.2857C54.3234 34.1598 53.9982 34.0018 53.69 33.8139L53.6892 33.8147ZM74.747 25.9237C73.9468 27.1505 73.0047 28.2773 71.9405 29.2805C72.8425 25.9168 73.8441 22.5814 74.9452 19.2742C76.0401 15.9945 77.2321 12.751 78.5215 9.54376C78.9118 15.1459 77.836 21.1984 74.7479 25.9228L74.747 25.9237Z"
                  fill="#1F1E21"
                />
              </svg>
            </div>
          </div>
        </div>
        <div class="contract_card ">
          <div class="contract_header d-flex ">
            <h3>Annuel Contract</h3>
            <div class="type_badge pending">
              Pending
            </div>
          </div>
          <div class="contract_body">
            <div class="num_contract d-flex">
              <h4>N°113 687 681 00012</h4>
              <svg
                width="25"
                height="28"
                viewBox="0 0 27 27"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M4.52051 8.11747C5.19023 7.42945 6.15185 7.10742 7.42591 7.10742H13.7959C15.071 7.10742 16.0291 7.42995 16.6983 8.11746C17.3327 8.76913 17.5727 9.62185 17.7278 10.3356L17.7292 10.3419L17.7292 10.342L18.7566 15.2373C18.8127 15.5046 18.7453 15.7829 18.5732 15.9949C18.401 16.2069 18.1425 16.3301 17.8694 16.3301H3.36457C3.09146 16.3301 2.83292 16.2069 2.66078 15.9949C2.48864 15.7829 2.42125 15.5046 2.47735 15.2373L3.50391 10.3461C3.64844 9.62473 3.88427 8.77109 4.52051 8.11747ZM5.81972 9.38213C5.57183 9.6368 5.4145 10.0382 5.28094 10.7059L5.27926 10.7144L5.27922 10.7144L4.48113 14.517H16.7528L15.9554 10.7176C15.8086 10.0432 15.6498 9.63966 15.3991 9.38213C15.183 9.16006 14.7692 8.92052 13.7959 8.92052H7.42591C6.45173 8.92052 6.0354 9.16056 5.81972 9.38213Z"
                  fill="#483A9D"
                />
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M2.93762 17.9738L2.42933 23.5045C2.37779 24.0084 2.78813 24.4881 3.3647 24.4881H5.06902C5.26016 24.4881 5.35881 24.468 5.40226 24.4548C5.40338 24.4525 5.40457 24.45 5.40582 24.4473C5.43056 24.3939 5.45426 24.3248 5.50036 24.1832L5.50233 24.1772L5.68518 23.6287C5.6907 23.6124 5.69643 23.5954 5.70238 23.5777C5.80385 23.2755 5.97367 22.7698 6.38241 22.3842C6.85635 21.9371 7.49738 21.7684 8.27217 21.7684H12.9137C13.6643 21.7684 14.3069 21.9112 14.7874 22.355C15.1963 22.7327 15.3696 23.2431 15.4777 23.5615C15.4852 23.5836 15.4924 23.6048 15.4994 23.6249L15.5022 23.6333L15.6805 24.168C15.7296 24.3057 15.7542 24.3739 15.7818 24.4314C15.7863 24.4407 15.7901 24.4481 15.7932 24.4539C15.8328 24.467 15.9274 24.4881 16.1168 24.4881H17.8212C18.3869 24.4881 18.8023 24.0166 18.7557 23.4957C18.7557 23.4952 18.7557 23.4948 18.7556 23.4943L18.2364 17.9762C18.2363 17.9756 18.2363 17.9751 18.2362 17.9746C18.1673 17.2678 18.0775 16.9269 17.9042 16.721C17.7756 16.5682 17.4421 16.317 16.3707 16.317H4.8031C3.73173 16.317 3.3982 16.5682 3.26956 16.721C3.09632 16.9268 3.0065 17.2676 2.93762 17.9738ZM15.7696 24.4435C15.7699 24.4433 15.773 24.4447 15.7783 24.4483C15.7719 24.4455 15.7693 24.4437 15.7696 24.4435ZM1.88246 15.5534C2.50928 14.8087 3.49326 14.5039 4.8031 14.5039H16.3707C17.6805 14.5039 18.6645 14.8087 19.2913 15.5534C19.8733 16.2448 19.9769 17.1425 20.041 17.8005L20.0412 17.8034L20.5613 23.3302C20.7073 24.9361 19.4306 26.3012 17.8212 26.3012H16.1168C15.5064 26.3012 14.96 26.1693 14.5469 25.7771C14.2093 25.4566 14.0628 25.0358 13.9875 24.8194C13.9811 24.801 13.9752 24.784 13.9698 24.7688L13.9635 24.7506L13.7836 24.2109C13.7164 24.0159 13.6753 23.8991 13.6299 23.8038C13.5895 23.7187 13.5646 23.6938 13.5572 23.6869C13.5532 23.6831 13.5291 23.6605 13.4458 23.6363C13.3505 23.6086 13.1864 23.5815 12.9137 23.5815H8.27217C7.75155 23.5815 7.63739 23.6926 7.62709 23.7026C7.6269 23.7028 7.62722 23.7025 7.62709 23.7026C7.57943 23.7476 7.53245 23.8275 7.40293 24.209L7.22344 24.7474C7.21929 24.7602 7.2149 24.7739 7.21023 24.7885C7.13781 25.0152 6.99815 25.4523 6.64507 25.7844C6.22748 26.1773 5.67454 26.3012 5.06902 26.3012H3.3647C1.76722 26.3012 0.462289 24.9463 0.625077 23.3251L1.13281 17.8005C1.19686 17.1425 1.30043 16.2448 1.88246 15.5534Z"
                  fill="#483A9D"
                />
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M1.53906 12.7034C1.53906 12.2028 1.94494 11.7969 2.44561 11.7969H3.35216C3.85284 11.7969 4.25871 12.2028 4.25871 12.7034C4.25871 13.2041 3.85284 13.61 3.35216 13.61H2.44561C1.94494 13.61 1.53906 13.2041 1.53906 12.7034Z"
                  fill="#483A9D"
                />
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M16.9512 12.7034C16.9512 12.2028 17.357 11.7969 17.8577 11.7969H18.7643C19.2649 11.7969 19.6708 12.2028 19.6708 12.7034C19.6708 13.2041 19.2649 13.61 18.7643 13.61H17.8577C17.357 13.61 16.9512 13.2041 16.9512 12.7034Z"
                  fill="#483A9D"
                />
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M4.25977 19.0501C4.25977 18.5494 4.66564 18.1436 5.16632 18.1436H7.88597C8.38664 18.1436 8.79252 18.5494 8.79252 19.0501C8.79252 19.5508 8.38664 19.9567 7.88597 19.9567H5.16632C4.66564 19.9567 4.25977 19.5508 4.25977 19.0501Z"
                  fill="#483A9D"
                />
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M12.418 19.0501C12.418 18.5494 12.8238 18.1436 13.3245 18.1436H16.0442C16.5448 18.1436 16.9507 18.5494 16.9507 19.0501C16.9507 19.5508 16.5448 19.9567 16.0442 19.9567H13.3245C12.8238 19.9567 12.418 19.5508 12.418 19.0501Z"
                  fill="#483A9D"
                />
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M22.0805 6.08335C21.3265 4.94708 20.1176 4.22529 18.8967 4.24249C18.3961 4.24954 17.996 4.66109 18.003 5.16172C18.0101 5.66234 18.4216 6.06246 18.9222 6.05541C19.4166 6.04845 20.0921 6.36472 20.5711 7.08794L20.5711 7.08796L20.5757 7.0947C21.0665 7.82156 21.0986 8.56004 20.9053 9.00876C20.7073 9.46859 20.9195 10.0019 21.3793 10.2C21.8391 10.3981 22.3724 10.1859 22.5705 9.72607C23.0536 8.60455 22.8449 7.21733 22.0805 6.08335Z"
                  fill="#483A9D"
                />
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M18.3358 1.11149C18.3964 0.614491 18.8483 0.260663 19.3453 0.321195C21.5193 0.585969 23.6775 1.9349 25.1022 4.06536C26.5254 6.1935 26.9567 8.69972 26.3704 10.8075C26.2362 11.2899 25.7364 11.5721 25.2541 11.438C24.7717 11.3038 24.4894 10.804 24.6236 10.3216C25.0527 8.77906 24.7586 6.81306 23.5951 5.07326C22.4332 3.33577 20.7235 2.31554 19.1261 2.12099C18.6291 2.06046 18.2753 1.60849 18.3358 1.11149Z"
                  fill="#483A9D"
                />
              </svg>
            </div>
            <div class="police_number d-flex">
              <h4>Police number :</h4>
              <p>66457871</p>
            </div>

            <div class="date_block">
              <h3>Dates :</h3>
              <div class="dates d-flex">
                <div class="date_debut">
                  <svg
                    width="15"
                    height="16"
                    viewBox="0 0 15 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M4.5112 3.38166C4.21253 3.38166 3.96484 3.13398 3.96484 2.83531V0.649874C3.96484 0.351198 4.21253 0.103516 4.5112 0.103516C4.80988 0.103516 5.05756 0.351198 5.05756 0.649874V2.83531C5.05756 3.13398 4.80988 3.38166 4.5112 3.38166Z"
                      fill="#483A9D"
                    />
                    <path
                      d="M10.3384 3.38166C10.0397 3.38166 9.79199 3.13398 9.79199 2.83531V0.649874C9.79199 0.351198 10.0397 0.103516 10.3384 0.103516C10.637 0.103516 10.8847 0.351198 10.8847 0.649874V2.83531C10.8847 3.13398 10.637 3.38166 10.3384 3.38166Z"
                      fill="#483A9D"
                    />
                    <path
                      d="M13.617 6.36127H1.23288C0.934206 6.36127 0.686523 6.11359 0.686523 5.81491C0.686523 5.51624 0.934206 5.26855 1.23288 5.26855H13.617C13.9157 5.26855 14.1634 5.51624 14.1634 5.81491C14.1634 6.11359 13.9157 6.36127 13.617 6.36127Z"
                      fill="#483A9D"
                    />
                    <path
                      d="M10.3388 15.7658H4.51101C1.85207 15.7658 0.322266 14.236 0.322266 11.5771V5.38504C0.322266 2.72609 1.85207 1.19629 4.51101 1.19629H10.3388C12.9978 1.19629 14.5276 2.72609 14.5276 5.38504V11.5771C14.5276 14.236 12.9978 15.7658 10.3388 15.7658ZM4.51101 2.28901C2.42757 2.28901 1.41498 3.30159 1.41498 5.38504V11.5771C1.41498 13.6605 2.42757 14.6731 4.51101 14.6731H10.3388C12.4223 14.6731 13.4349 13.6605 13.4349 11.5771V5.38504C13.4349 3.30159 12.4223 2.28901 10.3388 2.28901H4.51101Z"
                      fill="#483A9D"
                    />
                    <path
                      d="M4.87496 9.75579C4.78026 9.75579 4.68555 9.73395 4.59814 9.69752C4.51072 9.6611 4.4306 9.61009 4.35775 9.54453C4.29219 9.47168 4.24118 9.39156 4.20475 9.30414C4.16833 9.21672 4.14648 9.12202 4.14648 9.02731C4.14648 8.83791 4.22662 8.64851 4.35775 8.5101C4.4306 8.44454 4.51072 8.39353 4.59814 8.35711C4.72926 8.29883 4.87497 8.28426 5.02067 8.3134C5.06438 8.32068 5.10808 8.33525 5.15179 8.35711C5.1955 8.37167 5.2392 8.39355 5.28291 8.42269C5.31933 8.45183 5.35575 8.48096 5.39217 8.5101C5.42131 8.54653 5.45773 8.58294 5.47959 8.61937C5.50873 8.66308 5.5306 8.70678 5.54517 8.75049C5.56703 8.7942 5.58159 8.8379 5.58888 8.88161C5.59616 8.9326 5.60344 8.97632 5.60344 9.02731C5.60344 9.21672 5.5233 9.40612 5.39217 9.54453C5.25376 9.67565 5.06437 9.75579 4.87496 9.75579Z"
                      fill="#483A9D"
                    />
                    <path
                      d="M7.42477 9.75596C7.23536 9.75596 7.04596 9.67582 6.90755 9.54469C6.87841 9.50827 6.84928 9.47185 6.82014 9.43542C6.791 9.39172 6.76913 9.34801 6.75456 9.3043C6.7327 9.26059 6.71814 9.21689 6.71085 9.17318C6.70357 9.12219 6.69629 9.07847 6.69629 9.02748C6.69629 8.93278 6.71813 8.83807 6.75456 8.75065C6.79098 8.66324 6.84199 8.58311 6.90755 8.51027C7.11153 8.30629 7.43934 8.24071 7.70159 8.35727C7.79629 8.39369 7.86913 8.4447 7.94198 8.51027C8.07311 8.64868 8.15324 8.83807 8.15324 9.02748C8.15324 9.07847 8.14597 9.12219 8.13868 9.17318C8.1314 9.21689 8.11683 9.26059 8.09498 9.3043C8.08041 9.34801 8.05853 9.39172 8.02939 9.43542C8.00025 9.47185 7.97112 9.50827 7.94198 9.54469C7.86913 9.61025 7.79629 9.66126 7.70159 9.69769C7.61417 9.73411 7.51947 9.75596 7.42477 9.75596Z"
                      fill="#483A9D"
                    />
                    <path
                      d="M4.87496 12.3058C4.78026 12.3058 4.68555 12.2839 4.59814 12.2475C4.51072 12.2111 4.4306 12.1601 4.35775 12.0945C4.29219 12.0216 4.24118 11.9488 4.20475 11.8541C4.16833 11.7667 4.14648 11.672 4.14648 11.5773C4.14648 11.3879 4.22662 11.1985 4.35775 11.0601C4.4306 10.9945 4.51072 10.9435 4.59814 10.9071C4.86767 10.7905 5.1882 10.8561 5.39217 11.0601C5.42131 11.0965 5.45773 11.1329 5.47959 11.1693C5.50873 11.213 5.5306 11.2567 5.54517 11.3005C5.56703 11.3442 5.58159 11.3879 5.58888 11.4389C5.59616 11.4826 5.60344 11.5336 5.60344 11.5773C5.60344 11.7667 5.5233 11.9561 5.39217 12.0945C5.25376 12.2256 5.06437 12.3058 4.87496 12.3058Z"
                      fill="#483A9D"
                    />
                  </svg>
                  <span>01/01/2023</span>
                </div>
                <div class="date_fin">
                  <svg
                    width="15"
                    height="16"
                    viewBox="0 0 15 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M4.5112 3.38166C4.21253 3.38166 3.96484 3.13398 3.96484 2.83531V0.649874C3.96484 0.351198 4.21253 0.103516 4.5112 0.103516C4.80988 0.103516 5.05756 0.351198 5.05756 0.649874V2.83531C5.05756 3.13398 4.80988 3.38166 4.5112 3.38166Z"
                      fill="#483A9D"
                    />
                    <path
                      d="M10.3384 3.38166C10.0397 3.38166 9.79199 3.13398 9.79199 2.83531V0.649874C9.79199 0.351198 10.0397 0.103516 10.3384 0.103516C10.637 0.103516 10.8847 0.351198 10.8847 0.649874V2.83531C10.8847 3.13398 10.637 3.38166 10.3384 3.38166Z"
                      fill="#483A9D"
                    />
                    <path
                      d="M13.617 6.36127H1.23288C0.934206 6.36127 0.686523 6.11359 0.686523 5.81491C0.686523 5.51624 0.934206 5.26855 1.23288 5.26855H13.617C13.9157 5.26855 14.1634 5.51624 14.1634 5.81491C14.1634 6.11359 13.9157 6.36127 13.617 6.36127Z"
                      fill="#483A9D"
                    />
                    <path
                      d="M10.3388 15.7658H4.51101C1.85207 15.7658 0.322266 14.236 0.322266 11.5771V5.38504C0.322266 2.72609 1.85207 1.19629 4.51101 1.19629H10.3388C12.9978 1.19629 14.5276 2.72609 14.5276 5.38504V11.5771C14.5276 14.236 12.9978 15.7658 10.3388 15.7658ZM4.51101 2.28901C2.42757 2.28901 1.41498 3.30159 1.41498 5.38504V11.5771C1.41498 13.6605 2.42757 14.6731 4.51101 14.6731H10.3388C12.4223 14.6731 13.4349 13.6605 13.4349 11.5771V5.38504C13.4349 3.30159 12.4223 2.28901 10.3388 2.28901H4.51101Z"
                      fill="#483A9D"
                    />
                    <path
                      d="M4.87496 9.75579C4.78026 9.75579 4.68555 9.73395 4.59814 9.69752C4.51072 9.6611 4.4306 9.61009 4.35775 9.54453C4.29219 9.47168 4.24118 9.39156 4.20475 9.30414C4.16833 9.21672 4.14648 9.12202 4.14648 9.02731C4.14648 8.83791 4.22662 8.64851 4.35775 8.5101C4.4306 8.44454 4.51072 8.39353 4.59814 8.35711C4.72926 8.29883 4.87497 8.28426 5.02067 8.3134C5.06438 8.32068 5.10808 8.33525 5.15179 8.35711C5.1955 8.37167 5.2392 8.39355 5.28291 8.42269C5.31933 8.45183 5.35575 8.48096 5.39217 8.5101C5.42131 8.54653 5.45773 8.58294 5.47959 8.61937C5.50873 8.66308 5.5306 8.70678 5.54517 8.75049C5.56703 8.7942 5.58159 8.8379 5.58888 8.88161C5.59616 8.9326 5.60344 8.97632 5.60344 9.02731C5.60344 9.21672 5.5233 9.40612 5.39217 9.54453C5.25376 9.67565 5.06437 9.75579 4.87496 9.75579Z"
                      fill="#483A9D"
                    />
                    <path
                      d="M7.42477 9.75596C7.23536 9.75596 7.04596 9.67582 6.90755 9.54469C6.87841 9.50827 6.84928 9.47185 6.82014 9.43542C6.791 9.39172 6.76913 9.34801 6.75456 9.3043C6.7327 9.26059 6.71814 9.21689 6.71085 9.17318C6.70357 9.12219 6.69629 9.07847 6.69629 9.02748C6.69629 8.93278 6.71813 8.83807 6.75456 8.75065C6.79098 8.66324 6.84199 8.58311 6.90755 8.51027C7.11153 8.30629 7.43934 8.24071 7.70159 8.35727C7.79629 8.39369 7.86913 8.4447 7.94198 8.51027C8.07311 8.64868 8.15324 8.83807 8.15324 9.02748C8.15324 9.07847 8.14597 9.12219 8.13868 9.17318C8.1314 9.21689 8.11683 9.26059 8.09498 9.3043C8.08041 9.34801 8.05853 9.39172 8.02939 9.43542C8.00025 9.47185 7.97112 9.50827 7.94198 9.54469C7.86913 9.61025 7.79629 9.66126 7.70159 9.69769C7.61417 9.73411 7.51947 9.75596 7.42477 9.75596Z"
                      fill="#483A9D"
                    />
                    <path
                      d="M4.87496 12.3058C4.78026 12.3058 4.68555 12.2839 4.59814 12.2475C4.51072 12.2111 4.4306 12.1601 4.35775 12.0945C4.29219 12.0216 4.24118 11.9488 4.20475 11.8541C4.16833 11.7667 4.14648 11.672 4.14648 11.5773C4.14648 11.3879 4.22662 11.1985 4.35775 11.0601C4.4306 10.9945 4.51072 10.9435 4.59814 10.9071C4.86767 10.7905 5.1882 10.8561 5.39217 11.0601C5.42131 11.0965 5.45773 11.1329 5.47959 11.1693C5.50873 11.213 5.5306 11.2567 5.54517 11.3005C5.56703 11.3442 5.58159 11.3879 5.58888 11.4389C5.59616 11.4826 5.60344 11.5336 5.60344 11.5773C5.60344 11.7667 5.5233 11.9561 5.39217 12.0945C5.25376 12.2256 5.06437 12.3058 4.87496 12.3058Z"
                      fill="#483A9D"
                    />
                  </svg>
                  <span>01/01/2023</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </slide>
      <slide>
        <div
          class="annuel_contracts"
          :style="{
            'background-image': `url(${require('../../../../assets/images/info_bg.svg')})`,
          }"
        >
          <h4>Annuel Contract</h4>
          <div class="sub_contracts">
            N°117 856 658 22500
          </div>

          <div class="num_police">
            <h4 class="subtitle">N° police:</h4>
            <p>67597871</p>
          </div>

          <div class="validate_date">
            <h4 class="subtitle">Validation date:</h4>
            <div class="dates">
              <div class="start_date d-flex">
                <svg
                  width="16"
                  height="18"
                  viewBox="0 0 16 18"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M5 4.3125C4.6925 4.3125 4.4375 4.0575 4.4375 3.75V1.5C4.4375 1.1925 4.6925 0.9375 5 0.9375C5.3075 0.9375 5.5625 1.1925 5.5625 1.5V3.75C5.5625 4.0575 5.3075 4.3125 5 4.3125Z"
                    fill="#49CF48"
                  />
                  <path
                    d="M11 4.3125C10.6925 4.3125 10.4375 4.0575 10.4375 3.75V1.5C10.4375 1.1925 10.6925 0.9375 11 0.9375C11.3075 0.9375 11.5625 1.1925 11.5625 1.5V3.75C11.5625 4.0575 11.3075 4.3125 11 4.3125Z"
                    fill="#49CF48"
                  />
                  <path
                    d="M14.375 7.37988H1.625C1.3175 7.37988 1.0625 7.12488 1.0625 6.81738C1.0625 6.50988 1.3175 6.25488 1.625 6.25488H14.375C14.6825 6.25488 14.9375 6.50988 14.9375 6.81738C14.9375 7.12488 14.6825 7.37988 14.375 7.37988Z"
                    fill="#49CF48"
                  />
                  <path
                    d="M11 17.0625H5C2.2625 17.0625 0.6875 15.4875 0.6875 12.75V6.375C0.6875 3.6375 2.2625 2.0625 5 2.0625H11C13.7375 2.0625 15.3125 3.6375 15.3125 6.375V12.75C15.3125 15.4875 13.7375 17.0625 11 17.0625ZM5 3.1875C2.855 3.1875 1.8125 4.23 1.8125 6.375V12.75C1.8125 14.895 2.855 15.9375 5 15.9375H11C13.145 15.9375 14.1875 14.895 14.1875 12.75V6.375C14.1875 4.23 13.145 3.1875 11 3.1875H5Z"
                    fill="#49CF48"
                  />
                  <path
                    d="M5.375 10.875C5.2775 10.875 5.18 10.8525 5.09 10.815C5 10.7775 4.91751 10.725 4.84251 10.6575C4.77501 10.5825 4.72249 10.5 4.68499 10.41C4.64749 10.32 4.625 10.2225 4.625 10.125C4.625 9.93001 4.70751 9.73502 4.84251 9.59252C4.91751 9.52502 5 9.4725 5.09 9.435C5.225 9.375 5.37501 9.36 5.52501 9.39C5.57001 9.3975 5.615 9.4125 5.66 9.435C5.705 9.45 5.75 9.47252 5.795 9.50252C5.8325 9.53252 5.86999 9.56252 5.90749 9.59252C5.93749 9.63002 5.97499 9.66751 5.99749 9.70501C6.02749 9.75001 6.05001 9.79501 6.06501 9.84001C6.08751 9.885 6.10251 9.93 6.11001 9.975C6.11751 10.0275 6.125 10.0725 6.125 10.125C6.125 10.32 6.04249 10.515 5.90749 10.6575C5.76499 10.7925 5.57 10.875 5.375 10.875Z"
                    fill="#49CF48"
                  />
                  <path
                    d="M8 10.8751C7.805 10.8751 7.61001 10.7926 7.46751 10.6576C7.43751 10.6201 7.40751 10.5826 7.37751 10.5451C7.34751 10.5001 7.32499 10.4552 7.30999 10.4102C7.28749 10.3652 7.27249 10.3202 7.26499 10.2752C7.25749 10.2227 7.25 10.1776 7.25 10.1251C7.25 10.0276 7.27249 9.93015 7.30999 9.84015C7.34749 9.75015 7.40001 9.66766 7.46751 9.59266C7.67751 9.38266 8.015 9.31514 8.285 9.43514C8.3825 9.47264 8.45749 9.52516 8.53249 9.59266C8.66749 9.73516 8.75 9.93015 8.75 10.1251C8.75 10.1776 8.74251 10.2227 8.73501 10.2752C8.72751 10.3202 8.71251 10.3652 8.69001 10.4102C8.67501 10.4552 8.65249 10.5001 8.62249 10.5451C8.59249 10.5826 8.56249 10.6201 8.53249 10.6576C8.45749 10.7251 8.3825 10.7777 8.285 10.8152C8.195 10.8527 8.0975 10.8751 8 10.8751Z"
                    fill="#49CF48"
                  />
                  <path
                    d="M5.375 13.5001C5.2775 13.5001 5.18 13.4777 5.09 13.4402C5 13.4027 4.91751 13.3501 4.84251 13.2826C4.77501 13.2076 4.72249 13.1327 4.68499 13.0352C4.64749 12.9452 4.625 12.8476 4.625 12.7501C4.625 12.5551 4.70751 12.3602 4.84251 12.2177C4.91751 12.1502 5 12.0976 5.09 12.0601C5.3675 11.9401 5.69749 12.0077 5.90749 12.2177C5.93749 12.2552 5.97499 12.2927 5.99749 12.3302C6.02749 12.3752 6.05001 12.4201 6.06501 12.4651C6.08751 12.5101 6.10251 12.5551 6.11001 12.6076C6.11751 12.6526 6.125 12.7051 6.125 12.7501C6.125 12.9451 6.04249 13.1401 5.90749 13.2826C5.76499 13.4176 5.57 13.5001 5.375 13.5001Z"
                    fill="#49CF48"
                  />
                </svg>
                <span>05/01/2025</span>
              </div>
              <div class="end_date d-flex">
                <svg
                  width="16"
                  height="18"
                  viewBox="0 0 16 18"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M5 4.3125C4.6925 4.3125 4.4375 4.0575 4.4375 3.75V1.5C4.4375 1.1925 4.6925 0.9375 5 0.9375C5.3075 0.9375 5.5625 1.1925 5.5625 1.5V3.75C5.5625 4.0575 5.3075 4.3125 5 4.3125Z"
                    fill="#FA3559"
                  />
                  <path
                    d="M11 4.3125C10.6925 4.3125 10.4375 4.0575 10.4375 3.75V1.5C10.4375 1.1925 10.6925 0.9375 11 0.9375C11.3075 0.9375 11.5625 1.1925 11.5625 1.5V3.75C11.5625 4.0575 11.3075 4.3125 11 4.3125Z"
                    fill="#FA3559"
                  />
                  <path
                    d="M14.375 7.37988H1.625C1.3175 7.37988 1.0625 7.12488 1.0625 6.81738C1.0625 6.50988 1.3175 6.25488 1.625 6.25488H14.375C14.6825 6.25488 14.9375 6.50988 14.9375 6.81738C14.9375 7.12488 14.6825 7.37988 14.375 7.37988Z"
                    fill="#FA3559"
                  />
                  <path
                    d="M11 17.0625H5C2.2625 17.0625 0.6875 15.4875 0.6875 12.75V6.375C0.6875 3.6375 2.2625 2.0625 5 2.0625H11C13.7375 2.0625 15.3125 3.6375 15.3125 6.375V12.75C15.3125 15.4875 13.7375 17.0625 11 17.0625ZM5 3.1875C2.855 3.1875 1.8125 4.23 1.8125 6.375V12.75C1.8125 14.895 2.855 15.9375 5 15.9375H11C13.145 15.9375 14.1875 14.895 14.1875 12.75V6.375C14.1875 4.23 13.145 3.1875 11 3.1875H5Z"
                    fill="#FA3559"
                  />
                  <path
                    d="M5.375 10.875C5.2775 10.875 5.18 10.8525 5.09 10.815C5 10.7775 4.91751 10.725 4.84251 10.6575C4.77501 10.5825 4.72249 10.5 4.68499 10.41C4.64749 10.32 4.625 10.2225 4.625 10.125C4.625 9.93001 4.70751 9.73502 4.84251 9.59252C4.91751 9.52502 5 9.4725 5.09 9.435C5.225 9.375 5.37501 9.36 5.52501 9.39C5.57001 9.3975 5.615 9.4125 5.66 9.435C5.705 9.45 5.75 9.47252 5.795 9.50252C5.8325 9.53252 5.86999 9.56252 5.90749 9.59252C5.93749 9.63002 5.97499 9.66751 5.99749 9.70501C6.02749 9.75001 6.05001 9.79501 6.06501 9.84001C6.08751 9.885 6.10251 9.93 6.11001 9.975C6.11751 10.0275 6.125 10.0725 6.125 10.125C6.125 10.32 6.04249 10.515 5.90749 10.6575C5.76499 10.7925 5.57 10.875 5.375 10.875Z"
                    fill="#FA3559"
                  />
                  <path
                    d="M8 10.8751C7.805 10.8751 7.61001 10.7926 7.46751 10.6576C7.43751 10.6201 7.40751 10.5826 7.37751 10.5451C7.34751 10.5001 7.32499 10.4552 7.30999 10.4102C7.28749 10.3652 7.27249 10.3202 7.26499 10.2752C7.25749 10.2227 7.25 10.1776 7.25 10.1251C7.25 10.0276 7.27249 9.93015 7.30999 9.84015C7.34749 9.75015 7.40001 9.66766 7.46751 9.59266C7.67751 9.38266 8.015 9.31514 8.285 9.43514C8.3825 9.47264 8.45749 9.52516 8.53249 9.59266C8.66749 9.73516 8.75 9.93015 8.75 10.1251C8.75 10.1776 8.74251 10.2227 8.73501 10.2752C8.72751 10.3202 8.71251 10.3652 8.69001 10.4102C8.67501 10.4552 8.65249 10.5001 8.62249 10.5451C8.59249 10.5826 8.56249 10.6201 8.53249 10.6576C8.45749 10.7251 8.3825 10.7777 8.285 10.8152C8.195 10.8527 8.0975 10.8751 8 10.8751Z"
                    fill="#FA3559"
                  />
                  <path
                    d="M5.375 13.5001C5.2775 13.5001 5.18 13.4777 5.09 13.4402C5 13.4027 4.91751 13.3501 4.84251 13.2826C4.77501 13.2076 4.72249 13.1327 4.68499 13.0352C4.64749 12.9452 4.625 12.8476 4.625 12.7501C4.625 12.5551 4.70751 12.3602 4.84251 12.2177C4.91751 12.1502 5 12.0976 5.09 12.0601C5.3675 11.9401 5.69749 12.0077 5.90749 12.2177C5.93749 12.2552 5.97499 12.2927 5.99749 12.3302C6.02749 12.3752 6.05001 12.4201 6.06501 12.4651C6.08751 12.5101 6.10251 12.5551 6.11001 12.6076C6.11751 12.6526 6.125 12.7051 6.125 12.7501C6.125 12.9451 6.04249 13.1401 5.90749 13.2826C5.76499 13.4176 5.57 13.5001 5.375 13.5001Z"
                    fill="#FA3559"
                  />
                </svg>
                <span>31/02/2025</span>
              </div>
            </div>
          </div>

          <div class="car_identification">
            <h4 class="subtitle">
              Car identification
            </h4>
            <div class="car d-flex">
              <h5 class="subtitle_info">Brand</h5>
              <p class="info_insurance">Clio</p>
            </div>
            <div class="car d-flex">
              <h5 class="subtitle_info">Type</h5>
              <p class="info_insurance">05</p>
            </div>
            <div class="car d-flex">
              <h5 class="subtitle_info">Fiscal Power</h5>
              <p class="info_insurance">4</p>
            </div>
            <div class="car d-flex">
              <h5 class="subtitle_info">Car age</h5>
              <p class="info_insurance">15</p>
            </div>
            <div class="car d-flex">
              <h5 class="subtitle_info">Immatriculation N°</h5>
              <p class="info_insurance">8763 TU 111</p>
            </div>
            <div class="coverage d-flex mt-2">
              <h5 class="subtitle_info">Coverage per vehicle</h5>
              <p class="success_insurance">3.000 €</p>
            </div>
            <div class="prime d-flex">
              <h5 class="subtitle_info">Prime</h5>
              <p class="success_insurance">4,50 €</p>
            </div>
            <div class="asssured_risks">
              <h5 class="subtitle_info">Assured risks</h5>
              <ul class="ml-5">
                <li>
                  Body
                </li>
                <li>
                  carrosserie
                </li>
                <li>
                  tires
                </li>
                <li>
                  windshields and windows
                </li>
                <li>
                  exterior accessories
                </li>
              </ul>
            </div>
            <div class="signature_insurance">
              <h5 class="subtitle_info">Signature insurer:</h5>
              <svg
                width="79"
                height="67"
                viewBox="0 0 79 67"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M78.8531 8.67458C78.8514 8.62697 78.833 8.5815 78.8012 8.54622C78.7694 8.51093 78.7262 8.4881 78.6793 8.48175C78.6324 8.47539 78.5848 8.48593 78.5449 8.51151C78.5049 8.53708 78.4753 8.57603 78.4611 8.62149C75.6666 15.5109 73.3089 22.5718 71.4021 29.7617C68.6916 32.0858 65.2574 33.4594 61.6777 32.305C61.6438 32.2949 61.6078 32.2943 61.5736 32.3034C61.5394 32.3125 61.5084 32.3308 61.4838 32.3564C59.9657 34.326 57.3454 35.0967 55.0448 34.4193C55.3459 33.9048 55.5548 33.341 55.6623 32.7538C55.6703 32.7238 55.6715 32.6924 55.6656 32.6619C55.6598 32.6315 55.6471 32.6028 55.6285 32.578C55.61 32.5532 55.5861 32.533 55.5586 32.519C55.5312 32.5049 55.5009 32.4973 55.4701 32.4969C54.4971 32.4677 53.707 32.925 53.2376 33.7813C53.2118 33.8276 53.2049 33.882 53.2182 33.9333C53.2315 33.9846 53.2641 34.0286 53.309 34.0562C53.6613 34.288 54.0367 34.482 54.4291 34.6351C53.4196 36.0489 51.7076 36.9421 49.9216 36.6766C47.4016 36.3007 45.6692 33.7445 45.9549 31.2595C45.9796 31.0522 45.6768 31.0026 45.5833 31.1576C44.6294 32.7745 43.3557 34.1768 41.8412 35.2774C41.5894 33.7725 41.338 32.2682 41.0868 30.7645C41.0519 30.5564 40.7568 30.5932 40.7015 30.7645C38.9216 36.3173 35.4207 41.1494 30.7126 44.5514C31.4444 38.9638 32.5373 33.4301 33.9844 27.9857C36.8846 26.1874 39.385 23.6467 40.579 20.3995C42.0886 16.2976 40.9983 11.861 38.8296 8.22159C37.6399 6.25306 36.1896 4.45682 34.5185 2.88236C33.0931 1.52508 31.4032 0.142104 29.3595 0.0102293C25.927 -0.207279 23.8688 3.08531 22.8491 5.93861C22.0888 8.06488 21.7945 10.3059 21.479 12.5324C21.0997 15.211 20.7901 17.899 20.5137 20.5904C20.1114 24.5056 19.7797 28.4276 19.4081 32.3453C18.9137 32.4498 18.4218 32.5557 17.9325 32.663L0.143014 36.5858C-0.0321843 36.6244 -0.044091 36.8667 0.0945371 36.9532C5.68303 40.4556 11.7461 42.7762 17.9546 44.7347C17.6731 46.6032 17.3533 48.4657 16.9748 50.3145C15.4678 52.6706 13.9607 55.0272 12.4537 57.3844C11.3923 59.0457 10.3164 60.7001 9.27036 62.3717C8.40967 63.7469 7.67316 65.1513 7.55494 66.7989C7.55509 66.83 7.56238 66.8607 7.57625 66.8885C7.59012 66.9164 7.61018 66.9406 7.63488 66.9593C7.65958 66.9781 7.68824 66.9908 7.71863 66.9965C7.74902 67.0023 7.78032 67.0009 7.81008 66.9924C11.235 65.6583 13.413 62.6431 14.8197 59.342C16.0223 56.5161 16.7758 53.4881 17.3635 50.4447L18.2837 49.0026L20.5103 45.5182C27.7853 47.6967 35.2023 49.5258 42.2511 52.2832C46.3189 53.8743 50.2532 55.801 53.8975 58.2262C54.1127 58.3692 54.3126 58.0215 54.0991 57.8794C44.0158 51.17 32.1933 48.5873 20.7348 45.1663C23.6831 40.5541 26.6289 35.9422 29.5721 31.3305C29.9203 30.7859 30.2678 30.2416 30.6148 29.6975C31.0937 29.498 31.5682 29.2899 32.036 29.0638C32.5318 28.8241 33.0217 28.562 33.5031 28.282C32.0614 33.7745 30.9778 39.3559 30.2593 44.9907C30.2398 45.1397 30.4439 45.2476 30.5595 45.162C35.3098 41.8469 38.9043 37.1115 40.8342 31.626C41.061 32.9784 41.2878 34.3305 41.5146 35.6824C41.5228 35.7121 41.5376 35.7395 41.558 35.7625C41.5783 35.7855 41.6036 35.8034 41.632 35.815C41.6603 35.8266 41.6909 35.8315 41.7215 35.8293C41.752 35.8271 41.7816 35.8178 41.808 35.8023C43.2796 34.7811 44.5452 33.4876 45.5373 31.9908C45.6139 34.4159 47.4203 36.7177 49.8748 37.0799C51.8309 37.3685 53.7419 36.3581 54.828 34.773C55.6578 35.0304 56.5301 35.1195 57.3944 35.035C58.2587 34.9504 59.0977 34.694 59.8628 34.2806C60.3766 34.0044 60.8473 33.6538 61.2601 33.2401C61.5204 32.9764 61.5961 32.7871 61.9967 32.8223C62.3632 32.8557 62.7468 33.0072 63.1159 33.0603C64.3016 33.2245 65.5078 33.1488 66.6641 32.8377C68.3548 32.3915 69.8695 31.578 71.209 30.517C69.7627 36.07 68.5899 41.687 67.6906 47.3679C67.1106 51.0267 66.6476 54.7035 66.3018 58.3983C66.2771 58.6552 66.6768 58.6552 66.7007 58.3983C67.6048 48.8353 69.2876 39.3633 71.7321 30.0777C74.5957 27.5849 76.5892 23.9481 77.6803 20.4294C78.8477 16.6295 79.2465 12.6324 78.8531 8.67458ZM21.5224 15.2529C22.0369 11.1545 22.3303 6.4584 24.7814 2.96543C25.8521 1.43945 27.4332 0.285112 29.3655 0.415274C31.8021 0.580546 33.799 2.62461 35.3767 4.31672C38.4707 7.63329 41.0323 12.0151 40.8963 16.7035C40.7636 21.2575 37.8167 25.0339 34.1409 27.4231C34.692 25.3862 35.2913 23.3621 35.9388 21.3508C36.0111 21.1273 35.693 21.0083 35.574 21.1959L30.335 29.3927C26.9875 30.7713 23.3568 31.5155 19.818 32.2622C20.3632 26.5907 20.8131 20.9073 21.5224 15.2529ZM12.0948 42.313C8.15283 40.8367 4.32227 39.0692 0.728994 36.8676L17.0735 33.271C17.8338 33.0997 18.6044 32.9421 19.3698 32.7812C19.2326 34.2015 19.0872 35.6216 18.9335 37.0414C18.6673 39.4691 18.3713 41.9071 18.0141 44.3356C16.0257 43.7054 14.0441 43.0417 12.0948 42.3121V42.313ZM15.848 55.0826C14.6301 59.5715 12.5124 64.5407 7.99804 66.4718C8.20385 64.8653 9.03988 63.4798 9.89801 62.1293C10.8279 60.6696 11.7597 59.2109 12.6935 57.7535L16.7316 51.432C16.4637 52.6566 16.1754 53.8743 15.848 55.0826ZM17.5566 49.394C17.7505 48.3278 17.9291 47.2617 18.1026 46.205C18.1766 45.7537 18.2455 45.3007 18.3152 44.8486C18.9122 45.0341 19.5101 45.2174 20.1089 45.3983L17.5566 49.394ZM20.3334 45.0472C19.6802 44.8514 19.0282 44.6516 18.3773 44.4478C18.9667 40.5438 19.3979 36.6209 19.7738 32.6921C23.2174 31.9711 26.7018 31.2321 29.971 29.9518L20.3334 45.0472ZM30.9814 29.1195L35.1096 22.6568C34.5863 24.3403 34.097 26.033 33.6417 27.7348C32.7865 28.2531 31.899 28.7153 30.9848 29.1186L30.9814 29.1195ZM53.6892 33.8147C53.8544 33.5521 54.0795 33.333 54.3458 33.1756C54.6121 33.0182 54.9118 32.927 55.22 32.9096C55.1048 33.3944 54.9163 33.8585 54.6613 34.2857C54.3234 34.1598 53.9982 34.0018 53.69 33.8139L53.6892 33.8147ZM74.747 25.9237C73.9468 27.1505 73.0047 28.2773 71.9405 29.2805C72.8425 25.9168 73.8441 22.5814 74.9452 19.2742C76.0401 15.9945 77.2321 12.751 78.5215 9.54376C78.9118 15.1459 77.836 21.1984 74.7479 25.9228L74.747 25.9237Z"
                  fill="#1F1E21"
                />
              </svg>
            </div>
          </div>
        </div>
        <div class="contract_card ">
          <div class="contract_header d-flex ">
            <h3>Annuel Contract</h3>
            <div class="type_badge accepted">
              Accepted
            </div>
          </div>
          <div class="contract_body">
            <div class="num_contract d-flex">
              <h4>N°113 687 681 00012</h4>
              <svg
                width="25"
                height="28"
                viewBox="0 0 27 27"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M4.52051 8.11747C5.19023 7.42945 6.15185 7.10742 7.42591 7.10742H13.7959C15.071 7.10742 16.0291 7.42995 16.6983 8.11746C17.3327 8.76913 17.5727 9.62185 17.7278 10.3356L17.7292 10.3419L17.7292 10.342L18.7566 15.2373C18.8127 15.5046 18.7453 15.7829 18.5732 15.9949C18.401 16.2069 18.1425 16.3301 17.8694 16.3301H3.36457C3.09146 16.3301 2.83292 16.2069 2.66078 15.9949C2.48864 15.7829 2.42125 15.5046 2.47735 15.2373L3.50391 10.3461C3.64844 9.62473 3.88427 8.77109 4.52051 8.11747ZM5.81972 9.38213C5.57183 9.6368 5.4145 10.0382 5.28094 10.7059L5.27926 10.7144L5.27922 10.7144L4.48113 14.517H16.7528L15.9554 10.7176C15.8086 10.0432 15.6498 9.63966 15.3991 9.38213C15.183 9.16006 14.7692 8.92052 13.7959 8.92052H7.42591C6.45173 8.92052 6.0354 9.16056 5.81972 9.38213Z"
                  fill="#483A9D"
                />
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M2.93762 17.9738L2.42933 23.5045C2.37779 24.0084 2.78813 24.4881 3.3647 24.4881H5.06902C5.26016 24.4881 5.35881 24.468 5.40226 24.4548C5.40338 24.4525 5.40457 24.45 5.40582 24.4473C5.43056 24.3939 5.45426 24.3248 5.50036 24.1832L5.50233 24.1772L5.68518 23.6287C5.6907 23.6124 5.69643 23.5954 5.70238 23.5777C5.80385 23.2755 5.97367 22.7698 6.38241 22.3842C6.85635 21.9371 7.49738 21.7684 8.27217 21.7684H12.9137C13.6643 21.7684 14.3069 21.9112 14.7874 22.355C15.1963 22.7327 15.3696 23.2431 15.4777 23.5615C15.4852 23.5836 15.4924 23.6048 15.4994 23.6249L15.5022 23.6333L15.6805 24.168C15.7296 24.3057 15.7542 24.3739 15.7818 24.4314C15.7863 24.4407 15.7901 24.4481 15.7932 24.4539C15.8328 24.467 15.9274 24.4881 16.1168 24.4881H17.8212C18.3869 24.4881 18.8023 24.0166 18.7557 23.4957C18.7557 23.4952 18.7557 23.4948 18.7556 23.4943L18.2364 17.9762C18.2363 17.9756 18.2363 17.9751 18.2362 17.9746C18.1673 17.2678 18.0775 16.9269 17.9042 16.721C17.7756 16.5682 17.4421 16.317 16.3707 16.317H4.8031C3.73173 16.317 3.3982 16.5682 3.26956 16.721C3.09632 16.9268 3.0065 17.2676 2.93762 17.9738ZM15.7696 24.4435C15.7699 24.4433 15.773 24.4447 15.7783 24.4483C15.7719 24.4455 15.7693 24.4437 15.7696 24.4435ZM1.88246 15.5534C2.50928 14.8087 3.49326 14.5039 4.8031 14.5039H16.3707C17.6805 14.5039 18.6645 14.8087 19.2913 15.5534C19.8733 16.2448 19.9769 17.1425 20.041 17.8005L20.0412 17.8034L20.5613 23.3302C20.7073 24.9361 19.4306 26.3012 17.8212 26.3012H16.1168C15.5064 26.3012 14.96 26.1693 14.5469 25.7771C14.2093 25.4566 14.0628 25.0358 13.9875 24.8194C13.9811 24.801 13.9752 24.784 13.9698 24.7688L13.9635 24.7506L13.7836 24.2109C13.7164 24.0159 13.6753 23.8991 13.6299 23.8038C13.5895 23.7187 13.5646 23.6938 13.5572 23.6869C13.5532 23.6831 13.5291 23.6605 13.4458 23.6363C13.3505 23.6086 13.1864 23.5815 12.9137 23.5815H8.27217C7.75155 23.5815 7.63739 23.6926 7.62709 23.7026C7.6269 23.7028 7.62722 23.7025 7.62709 23.7026C7.57943 23.7476 7.53245 23.8275 7.40293 24.209L7.22344 24.7474C7.21929 24.7602 7.2149 24.7739 7.21023 24.7885C7.13781 25.0152 6.99815 25.4523 6.64507 25.7844C6.22748 26.1773 5.67454 26.3012 5.06902 26.3012H3.3647C1.76722 26.3012 0.462289 24.9463 0.625077 23.3251L1.13281 17.8005C1.19686 17.1425 1.30043 16.2448 1.88246 15.5534Z"
                  fill="#483A9D"
                />
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M1.53906 12.7034C1.53906 12.2028 1.94494 11.7969 2.44561 11.7969H3.35216C3.85284 11.7969 4.25871 12.2028 4.25871 12.7034C4.25871 13.2041 3.85284 13.61 3.35216 13.61H2.44561C1.94494 13.61 1.53906 13.2041 1.53906 12.7034Z"
                  fill="#483A9D"
                />
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M16.9512 12.7034C16.9512 12.2028 17.357 11.7969 17.8577 11.7969H18.7643C19.2649 11.7969 19.6708 12.2028 19.6708 12.7034C19.6708 13.2041 19.2649 13.61 18.7643 13.61H17.8577C17.357 13.61 16.9512 13.2041 16.9512 12.7034Z"
                  fill="#483A9D"
                />
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M4.25977 19.0501C4.25977 18.5494 4.66564 18.1436 5.16632 18.1436H7.88597C8.38664 18.1436 8.79252 18.5494 8.79252 19.0501C8.79252 19.5508 8.38664 19.9567 7.88597 19.9567H5.16632C4.66564 19.9567 4.25977 19.5508 4.25977 19.0501Z"
                  fill="#483A9D"
                />
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M12.418 19.0501C12.418 18.5494 12.8238 18.1436 13.3245 18.1436H16.0442C16.5448 18.1436 16.9507 18.5494 16.9507 19.0501C16.9507 19.5508 16.5448 19.9567 16.0442 19.9567H13.3245C12.8238 19.9567 12.418 19.5508 12.418 19.0501Z"
                  fill="#483A9D"
                />
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M22.0805 6.08335C21.3265 4.94708 20.1176 4.22529 18.8967 4.24249C18.3961 4.24954 17.996 4.66109 18.003 5.16172C18.0101 5.66234 18.4216 6.06246 18.9222 6.05541C19.4166 6.04845 20.0921 6.36472 20.5711 7.08794L20.5711 7.08796L20.5757 7.0947C21.0665 7.82156 21.0986 8.56004 20.9053 9.00876C20.7073 9.46859 20.9195 10.0019 21.3793 10.2C21.8391 10.3981 22.3724 10.1859 22.5705 9.72607C23.0536 8.60455 22.8449 7.21733 22.0805 6.08335Z"
                  fill="#483A9D"
                />
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M18.3358 1.11149C18.3964 0.614491 18.8483 0.260663 19.3453 0.321195C21.5193 0.585969 23.6775 1.9349 25.1022 4.06536C26.5254 6.1935 26.9567 8.69972 26.3704 10.8075C26.2362 11.2899 25.7364 11.5721 25.2541 11.438C24.7717 11.3038 24.4894 10.804 24.6236 10.3216C25.0527 8.77906 24.7586 6.81306 23.5951 5.07326C22.4332 3.33577 20.7235 2.31554 19.1261 2.12099C18.6291 2.06046 18.2753 1.60849 18.3358 1.11149Z"
                  fill="#483A9D"
                />
              </svg>
            </div>
            <div class="police_number d-flex">
              <h4>Police number :</h4>
              <p>66457871</p>
            </div>

            <div class="date_block">
              <h3>Dates :</h3>
              <div class="dates d-flex">
                <div class="date_debut">
                  <svg
                    width="15"
                    height="16"
                    viewBox="0 0 15 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M4.5112 3.38166C4.21253 3.38166 3.96484 3.13398 3.96484 2.83531V0.649874C3.96484 0.351198 4.21253 0.103516 4.5112 0.103516C4.80988 0.103516 5.05756 0.351198 5.05756 0.649874V2.83531C5.05756 3.13398 4.80988 3.38166 4.5112 3.38166Z"
                      fill="#483A9D"
                    />
                    <path
                      d="M10.3384 3.38166C10.0397 3.38166 9.79199 3.13398 9.79199 2.83531V0.649874C9.79199 0.351198 10.0397 0.103516 10.3384 0.103516C10.637 0.103516 10.8847 0.351198 10.8847 0.649874V2.83531C10.8847 3.13398 10.637 3.38166 10.3384 3.38166Z"
                      fill="#483A9D"
                    />
                    <path
                      d="M13.617 6.36127H1.23288C0.934206 6.36127 0.686523 6.11359 0.686523 5.81491C0.686523 5.51624 0.934206 5.26855 1.23288 5.26855H13.617C13.9157 5.26855 14.1634 5.51624 14.1634 5.81491C14.1634 6.11359 13.9157 6.36127 13.617 6.36127Z"
                      fill="#483A9D"
                    />
                    <path
                      d="M10.3388 15.7658H4.51101C1.85207 15.7658 0.322266 14.236 0.322266 11.5771V5.38504C0.322266 2.72609 1.85207 1.19629 4.51101 1.19629H10.3388C12.9978 1.19629 14.5276 2.72609 14.5276 5.38504V11.5771C14.5276 14.236 12.9978 15.7658 10.3388 15.7658ZM4.51101 2.28901C2.42757 2.28901 1.41498 3.30159 1.41498 5.38504V11.5771C1.41498 13.6605 2.42757 14.6731 4.51101 14.6731H10.3388C12.4223 14.6731 13.4349 13.6605 13.4349 11.5771V5.38504C13.4349 3.30159 12.4223 2.28901 10.3388 2.28901H4.51101Z"
                      fill="#483A9D"
                    />
                    <path
                      d="M4.87496 9.75579C4.78026 9.75579 4.68555 9.73395 4.59814 9.69752C4.51072 9.6611 4.4306 9.61009 4.35775 9.54453C4.29219 9.47168 4.24118 9.39156 4.20475 9.30414C4.16833 9.21672 4.14648 9.12202 4.14648 9.02731C4.14648 8.83791 4.22662 8.64851 4.35775 8.5101C4.4306 8.44454 4.51072 8.39353 4.59814 8.35711C4.72926 8.29883 4.87497 8.28426 5.02067 8.3134C5.06438 8.32068 5.10808 8.33525 5.15179 8.35711C5.1955 8.37167 5.2392 8.39355 5.28291 8.42269C5.31933 8.45183 5.35575 8.48096 5.39217 8.5101C5.42131 8.54653 5.45773 8.58294 5.47959 8.61937C5.50873 8.66308 5.5306 8.70678 5.54517 8.75049C5.56703 8.7942 5.58159 8.8379 5.58888 8.88161C5.59616 8.9326 5.60344 8.97632 5.60344 9.02731C5.60344 9.21672 5.5233 9.40612 5.39217 9.54453C5.25376 9.67565 5.06437 9.75579 4.87496 9.75579Z"
                      fill="#483A9D"
                    />
                    <path
                      d="M7.42477 9.75596C7.23536 9.75596 7.04596 9.67582 6.90755 9.54469C6.87841 9.50827 6.84928 9.47185 6.82014 9.43542C6.791 9.39172 6.76913 9.34801 6.75456 9.3043C6.7327 9.26059 6.71814 9.21689 6.71085 9.17318C6.70357 9.12219 6.69629 9.07847 6.69629 9.02748C6.69629 8.93278 6.71813 8.83807 6.75456 8.75065C6.79098 8.66324 6.84199 8.58311 6.90755 8.51027C7.11153 8.30629 7.43934 8.24071 7.70159 8.35727C7.79629 8.39369 7.86913 8.4447 7.94198 8.51027C8.07311 8.64868 8.15324 8.83807 8.15324 9.02748C8.15324 9.07847 8.14597 9.12219 8.13868 9.17318C8.1314 9.21689 8.11683 9.26059 8.09498 9.3043C8.08041 9.34801 8.05853 9.39172 8.02939 9.43542C8.00025 9.47185 7.97112 9.50827 7.94198 9.54469C7.86913 9.61025 7.79629 9.66126 7.70159 9.69769C7.61417 9.73411 7.51947 9.75596 7.42477 9.75596Z"
                      fill="#483A9D"
                    />
                    <path
                      d="M4.87496 12.3058C4.78026 12.3058 4.68555 12.2839 4.59814 12.2475C4.51072 12.2111 4.4306 12.1601 4.35775 12.0945C4.29219 12.0216 4.24118 11.9488 4.20475 11.8541C4.16833 11.7667 4.14648 11.672 4.14648 11.5773C4.14648 11.3879 4.22662 11.1985 4.35775 11.0601C4.4306 10.9945 4.51072 10.9435 4.59814 10.9071C4.86767 10.7905 5.1882 10.8561 5.39217 11.0601C5.42131 11.0965 5.45773 11.1329 5.47959 11.1693C5.50873 11.213 5.5306 11.2567 5.54517 11.3005C5.56703 11.3442 5.58159 11.3879 5.58888 11.4389C5.59616 11.4826 5.60344 11.5336 5.60344 11.5773C5.60344 11.7667 5.5233 11.9561 5.39217 12.0945C5.25376 12.2256 5.06437 12.3058 4.87496 12.3058Z"
                      fill="#483A9D"
                    />
                  </svg>
                  <span>01/01/2023</span>
                </div>
                <div class="date_fin">
                  <svg
                    width="15"
                    height="16"
                    viewBox="0 0 15 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M4.5112 3.38166C4.21253 3.38166 3.96484 3.13398 3.96484 2.83531V0.649874C3.96484 0.351198 4.21253 0.103516 4.5112 0.103516C4.80988 0.103516 5.05756 0.351198 5.05756 0.649874V2.83531C5.05756 3.13398 4.80988 3.38166 4.5112 3.38166Z"
                      fill="#483A9D"
                    />
                    <path
                      d="M10.3384 3.38166C10.0397 3.38166 9.79199 3.13398 9.79199 2.83531V0.649874C9.79199 0.351198 10.0397 0.103516 10.3384 0.103516C10.637 0.103516 10.8847 0.351198 10.8847 0.649874V2.83531C10.8847 3.13398 10.637 3.38166 10.3384 3.38166Z"
                      fill="#483A9D"
                    />
                    <path
                      d="M13.617 6.36127H1.23288C0.934206 6.36127 0.686523 6.11359 0.686523 5.81491C0.686523 5.51624 0.934206 5.26855 1.23288 5.26855H13.617C13.9157 5.26855 14.1634 5.51624 14.1634 5.81491C14.1634 6.11359 13.9157 6.36127 13.617 6.36127Z"
                      fill="#483A9D"
                    />
                    <path
                      d="M10.3388 15.7658H4.51101C1.85207 15.7658 0.322266 14.236 0.322266 11.5771V5.38504C0.322266 2.72609 1.85207 1.19629 4.51101 1.19629H10.3388C12.9978 1.19629 14.5276 2.72609 14.5276 5.38504V11.5771C14.5276 14.236 12.9978 15.7658 10.3388 15.7658ZM4.51101 2.28901C2.42757 2.28901 1.41498 3.30159 1.41498 5.38504V11.5771C1.41498 13.6605 2.42757 14.6731 4.51101 14.6731H10.3388C12.4223 14.6731 13.4349 13.6605 13.4349 11.5771V5.38504C13.4349 3.30159 12.4223 2.28901 10.3388 2.28901H4.51101Z"
                      fill="#483A9D"
                    />
                    <path
                      d="M4.87496 9.75579C4.78026 9.75579 4.68555 9.73395 4.59814 9.69752C4.51072 9.6611 4.4306 9.61009 4.35775 9.54453C4.29219 9.47168 4.24118 9.39156 4.20475 9.30414C4.16833 9.21672 4.14648 9.12202 4.14648 9.02731C4.14648 8.83791 4.22662 8.64851 4.35775 8.5101C4.4306 8.44454 4.51072 8.39353 4.59814 8.35711C4.72926 8.29883 4.87497 8.28426 5.02067 8.3134C5.06438 8.32068 5.10808 8.33525 5.15179 8.35711C5.1955 8.37167 5.2392 8.39355 5.28291 8.42269C5.31933 8.45183 5.35575 8.48096 5.39217 8.5101C5.42131 8.54653 5.45773 8.58294 5.47959 8.61937C5.50873 8.66308 5.5306 8.70678 5.54517 8.75049C5.56703 8.7942 5.58159 8.8379 5.58888 8.88161C5.59616 8.9326 5.60344 8.97632 5.60344 9.02731C5.60344 9.21672 5.5233 9.40612 5.39217 9.54453C5.25376 9.67565 5.06437 9.75579 4.87496 9.75579Z"
                      fill="#483A9D"
                    />
                    <path
                      d="M7.42477 9.75596C7.23536 9.75596 7.04596 9.67582 6.90755 9.54469C6.87841 9.50827 6.84928 9.47185 6.82014 9.43542C6.791 9.39172 6.76913 9.34801 6.75456 9.3043C6.7327 9.26059 6.71814 9.21689 6.71085 9.17318C6.70357 9.12219 6.69629 9.07847 6.69629 9.02748C6.69629 8.93278 6.71813 8.83807 6.75456 8.75065C6.79098 8.66324 6.84199 8.58311 6.90755 8.51027C7.11153 8.30629 7.43934 8.24071 7.70159 8.35727C7.79629 8.39369 7.86913 8.4447 7.94198 8.51027C8.07311 8.64868 8.15324 8.83807 8.15324 9.02748C8.15324 9.07847 8.14597 9.12219 8.13868 9.17318C8.1314 9.21689 8.11683 9.26059 8.09498 9.3043C8.08041 9.34801 8.05853 9.39172 8.02939 9.43542C8.00025 9.47185 7.97112 9.50827 7.94198 9.54469C7.86913 9.61025 7.79629 9.66126 7.70159 9.69769C7.61417 9.73411 7.51947 9.75596 7.42477 9.75596Z"
                      fill="#483A9D"
                    />
                    <path
                      d="M4.87496 12.3058C4.78026 12.3058 4.68555 12.2839 4.59814 12.2475C4.51072 12.2111 4.4306 12.1601 4.35775 12.0945C4.29219 12.0216 4.24118 11.9488 4.20475 11.8541C4.16833 11.7667 4.14648 11.672 4.14648 11.5773C4.14648 11.3879 4.22662 11.1985 4.35775 11.0601C4.4306 10.9945 4.51072 10.9435 4.59814 10.9071C4.86767 10.7905 5.1882 10.8561 5.39217 11.0601C5.42131 11.0965 5.45773 11.1329 5.47959 11.1693C5.50873 11.213 5.5306 11.2567 5.54517 11.3005C5.56703 11.3442 5.58159 11.3879 5.58888 11.4389C5.59616 11.4826 5.60344 11.5336 5.60344 11.5773C5.60344 11.7667 5.5233 11.9561 5.39217 12.0945C5.25376 12.2256 5.06437 12.3058 4.87496 12.3058Z"
                      fill="#483A9D"
                    />
                  </svg>
                  <span>01/01/2023</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </slide>
      <slide>
        <div
          class="annuel_contracts"
          :style="{
            'background-image': `url(${require('../../../../assets/images/info_bg.svg')})`,
          }"
        >
          <h4>Annuel Contract</h4>
          <div class="sub_contracts">
            N°110 645 673 11012
          </div>

          <div class="num_police">
            <h4 class="subtitle">N° police:</h4>
            <p>67597871</p>
          </div>

          <div class="validate_date">
            <h4 class="subtitle">Validation date:</h4>
            <div class="dates">
              <div class="start_date d-flex">
                <svg
                  width="16"
                  height="18"
                  viewBox="0 0 16 18"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M5 4.3125C4.6925 4.3125 4.4375 4.0575 4.4375 3.75V1.5C4.4375 1.1925 4.6925 0.9375 5 0.9375C5.3075 0.9375 5.5625 1.1925 5.5625 1.5V3.75C5.5625 4.0575 5.3075 4.3125 5 4.3125Z"
                    fill="#49CF48"
                  />
                  <path
                    d="M11 4.3125C10.6925 4.3125 10.4375 4.0575 10.4375 3.75V1.5C10.4375 1.1925 10.6925 0.9375 11 0.9375C11.3075 0.9375 11.5625 1.1925 11.5625 1.5V3.75C11.5625 4.0575 11.3075 4.3125 11 4.3125Z"
                    fill="#49CF48"
                  />
                  <path
                    d="M14.375 7.37988H1.625C1.3175 7.37988 1.0625 7.12488 1.0625 6.81738C1.0625 6.50988 1.3175 6.25488 1.625 6.25488H14.375C14.6825 6.25488 14.9375 6.50988 14.9375 6.81738C14.9375 7.12488 14.6825 7.37988 14.375 7.37988Z"
                    fill="#49CF48"
                  />
                  <path
                    d="M11 17.0625H5C2.2625 17.0625 0.6875 15.4875 0.6875 12.75V6.375C0.6875 3.6375 2.2625 2.0625 5 2.0625H11C13.7375 2.0625 15.3125 3.6375 15.3125 6.375V12.75C15.3125 15.4875 13.7375 17.0625 11 17.0625ZM5 3.1875C2.855 3.1875 1.8125 4.23 1.8125 6.375V12.75C1.8125 14.895 2.855 15.9375 5 15.9375H11C13.145 15.9375 14.1875 14.895 14.1875 12.75V6.375C14.1875 4.23 13.145 3.1875 11 3.1875H5Z"
                    fill="#49CF48"
                  />
                  <path
                    d="M5.375 10.875C5.2775 10.875 5.18 10.8525 5.09 10.815C5 10.7775 4.91751 10.725 4.84251 10.6575C4.77501 10.5825 4.72249 10.5 4.68499 10.41C4.64749 10.32 4.625 10.2225 4.625 10.125C4.625 9.93001 4.70751 9.73502 4.84251 9.59252C4.91751 9.52502 5 9.4725 5.09 9.435C5.225 9.375 5.37501 9.36 5.52501 9.39C5.57001 9.3975 5.615 9.4125 5.66 9.435C5.705 9.45 5.75 9.47252 5.795 9.50252C5.8325 9.53252 5.86999 9.56252 5.90749 9.59252C5.93749 9.63002 5.97499 9.66751 5.99749 9.70501C6.02749 9.75001 6.05001 9.79501 6.06501 9.84001C6.08751 9.885 6.10251 9.93 6.11001 9.975C6.11751 10.0275 6.125 10.0725 6.125 10.125C6.125 10.32 6.04249 10.515 5.90749 10.6575C5.76499 10.7925 5.57 10.875 5.375 10.875Z"
                    fill="#49CF48"
                  />
                  <path
                    d="M8 10.8751C7.805 10.8751 7.61001 10.7926 7.46751 10.6576C7.43751 10.6201 7.40751 10.5826 7.37751 10.5451C7.34751 10.5001 7.32499 10.4552 7.30999 10.4102C7.28749 10.3652 7.27249 10.3202 7.26499 10.2752C7.25749 10.2227 7.25 10.1776 7.25 10.1251C7.25 10.0276 7.27249 9.93015 7.30999 9.84015C7.34749 9.75015 7.40001 9.66766 7.46751 9.59266C7.67751 9.38266 8.015 9.31514 8.285 9.43514C8.3825 9.47264 8.45749 9.52516 8.53249 9.59266C8.66749 9.73516 8.75 9.93015 8.75 10.1251C8.75 10.1776 8.74251 10.2227 8.73501 10.2752C8.72751 10.3202 8.71251 10.3652 8.69001 10.4102C8.67501 10.4552 8.65249 10.5001 8.62249 10.5451C8.59249 10.5826 8.56249 10.6201 8.53249 10.6576C8.45749 10.7251 8.3825 10.7777 8.285 10.8152C8.195 10.8527 8.0975 10.8751 8 10.8751Z"
                    fill="#49CF48"
                  />
                  <path
                    d="M5.375 13.5001C5.2775 13.5001 5.18 13.4777 5.09 13.4402C5 13.4027 4.91751 13.3501 4.84251 13.2826C4.77501 13.2076 4.72249 13.1327 4.68499 13.0352C4.64749 12.9452 4.625 12.8476 4.625 12.7501C4.625 12.5551 4.70751 12.3602 4.84251 12.2177C4.91751 12.1502 5 12.0976 5.09 12.0601C5.3675 11.9401 5.69749 12.0077 5.90749 12.2177C5.93749 12.2552 5.97499 12.2927 5.99749 12.3302C6.02749 12.3752 6.05001 12.4201 6.06501 12.4651C6.08751 12.5101 6.10251 12.5551 6.11001 12.6076C6.11751 12.6526 6.125 12.7051 6.125 12.7501C6.125 12.9451 6.04249 13.1401 5.90749 13.2826C5.76499 13.4176 5.57 13.5001 5.375 13.5001Z"
                    fill="#49CF48"
                  />
                </svg>
                <span>12/07/2020</span>
              </div>
              <div class="end_date d-flex">
                <svg
                  width="16"
                  height="18"
                  viewBox="0 0 16 18"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M5 4.3125C4.6925 4.3125 4.4375 4.0575 4.4375 3.75V1.5C4.4375 1.1925 4.6925 0.9375 5 0.9375C5.3075 0.9375 5.5625 1.1925 5.5625 1.5V3.75C5.5625 4.0575 5.3075 4.3125 5 4.3125Z"
                    fill="#FA3559"
                  />
                  <path
                    d="M11 4.3125C10.6925 4.3125 10.4375 4.0575 10.4375 3.75V1.5C10.4375 1.1925 10.6925 0.9375 11 0.9375C11.3075 0.9375 11.5625 1.1925 11.5625 1.5V3.75C11.5625 4.0575 11.3075 4.3125 11 4.3125Z"
                    fill="#FA3559"
                  />
                  <path
                    d="M14.375 7.37988H1.625C1.3175 7.37988 1.0625 7.12488 1.0625 6.81738C1.0625 6.50988 1.3175 6.25488 1.625 6.25488H14.375C14.6825 6.25488 14.9375 6.50988 14.9375 6.81738C14.9375 7.12488 14.6825 7.37988 14.375 7.37988Z"
                    fill="#FA3559"
                  />
                  <path
                    d="M11 17.0625H5C2.2625 17.0625 0.6875 15.4875 0.6875 12.75V6.375C0.6875 3.6375 2.2625 2.0625 5 2.0625H11C13.7375 2.0625 15.3125 3.6375 15.3125 6.375V12.75C15.3125 15.4875 13.7375 17.0625 11 17.0625ZM5 3.1875C2.855 3.1875 1.8125 4.23 1.8125 6.375V12.75C1.8125 14.895 2.855 15.9375 5 15.9375H11C13.145 15.9375 14.1875 14.895 14.1875 12.75V6.375C14.1875 4.23 13.145 3.1875 11 3.1875H5Z"
                    fill="#FA3559"
                  />
                  <path
                    d="M5.375 10.875C5.2775 10.875 5.18 10.8525 5.09 10.815C5 10.7775 4.91751 10.725 4.84251 10.6575C4.77501 10.5825 4.72249 10.5 4.68499 10.41C4.64749 10.32 4.625 10.2225 4.625 10.125C4.625 9.93001 4.70751 9.73502 4.84251 9.59252C4.91751 9.52502 5 9.4725 5.09 9.435C5.225 9.375 5.37501 9.36 5.52501 9.39C5.57001 9.3975 5.615 9.4125 5.66 9.435C5.705 9.45 5.75 9.47252 5.795 9.50252C5.8325 9.53252 5.86999 9.56252 5.90749 9.59252C5.93749 9.63002 5.97499 9.66751 5.99749 9.70501C6.02749 9.75001 6.05001 9.79501 6.06501 9.84001C6.08751 9.885 6.10251 9.93 6.11001 9.975C6.11751 10.0275 6.125 10.0725 6.125 10.125C6.125 10.32 6.04249 10.515 5.90749 10.6575C5.76499 10.7925 5.57 10.875 5.375 10.875Z"
                    fill="#FA3559"
                  />
                  <path
                    d="M8 10.8751C7.805 10.8751 7.61001 10.7926 7.46751 10.6576C7.43751 10.6201 7.40751 10.5826 7.37751 10.5451C7.34751 10.5001 7.32499 10.4552 7.30999 10.4102C7.28749 10.3652 7.27249 10.3202 7.26499 10.2752C7.25749 10.2227 7.25 10.1776 7.25 10.1251C7.25 10.0276 7.27249 9.93015 7.30999 9.84015C7.34749 9.75015 7.40001 9.66766 7.46751 9.59266C7.67751 9.38266 8.015 9.31514 8.285 9.43514C8.3825 9.47264 8.45749 9.52516 8.53249 9.59266C8.66749 9.73516 8.75 9.93015 8.75 10.1251C8.75 10.1776 8.74251 10.2227 8.73501 10.2752C8.72751 10.3202 8.71251 10.3652 8.69001 10.4102C8.67501 10.4552 8.65249 10.5001 8.62249 10.5451C8.59249 10.5826 8.56249 10.6201 8.53249 10.6576C8.45749 10.7251 8.3825 10.7777 8.285 10.8152C8.195 10.8527 8.0975 10.8751 8 10.8751Z"
                    fill="#FA3559"
                  />
                  <path
                    d="M5.375 13.5001C5.2775 13.5001 5.18 13.4777 5.09 13.4402C5 13.4027 4.91751 13.3501 4.84251 13.2826C4.77501 13.2076 4.72249 13.1327 4.68499 13.0352C4.64749 12.9452 4.625 12.8476 4.625 12.7501C4.625 12.5551 4.70751 12.3602 4.84251 12.2177C4.91751 12.1502 5 12.0976 5.09 12.0601C5.3675 11.9401 5.69749 12.0077 5.90749 12.2177C5.93749 12.2552 5.97499 12.2927 5.99749 12.3302C6.02749 12.3752 6.05001 12.4201 6.06501 12.4651C6.08751 12.5101 6.10251 12.5551 6.11001 12.6076C6.11751 12.6526 6.125 12.7051 6.125 12.7501C6.125 12.9451 6.04249 13.1401 5.90749 13.2826C5.76499 13.4176 5.57 13.5001 5.375 13.5001Z"
                    fill="#FA3559"
                  />
                </svg>
                <span>12/04/2021</span>
              </div>
            </div>
          </div>

          <div class="car_identification">
            <h4 class="subtitle">
              Car identification
            </h4>
            <div class="car d-flex">
              <h5 class="subtitle_info">Brand</h5>
              <p class="info_insurance">BMW</p>
            </div>
            <div class="car d-flex">
              <h5 class="subtitle_info">Type</h5>
              <p class="info_insurance">08</p>
            </div>
            <div class="car d-flex">
              <h5 class="subtitle_info">Fiscal Power</h5>
              <p class="info_insurance">8</p>
            </div>
            <div class="car d-flex">
              <h5 class="subtitle_info">Car age</h5>
              <p class="info_insurance">2</p>
            </div>
            <div class="car d-flex">
              <h5 class="subtitle_info">Immatriculation N°</h5>
              <p class="info_insurance">9413 TU 102</p>
            </div>
            <div class="coverage d-flex mt-2">
              <h5 class="subtitle_info">Coverage per vehicle</h5>
              <p class="success_insurance">3.000 €</p>
            </div>
            <div class="prime d-flex">
              <h5 class="subtitle_info">Prime</h5>
              <p class="success_insurance">4,50 €</p>
            </div>
            <div class="asssured_risks">
              <h5 class="subtitle_info">Assured risks</h5>
              <ul class="ml-5">
                <li>
                  Body
                </li>
                <li>
                  carrosserie
                </li>
                <li>
                  tires
                </li>
                <li>
                  windshields and windows
                </li>
                <li>
                  exterior accessories
                </li>
              </ul>
            </div>
            <div class="signature_insurance">
              <h5 class="subtitle_info">Signature insurer:</h5>
              <svg
                width="79"
                height="67"
                viewBox="0 0 79 67"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M78.8531 8.67458C78.8514 8.62697 78.833 8.5815 78.8012 8.54622C78.7694 8.51093 78.7262 8.4881 78.6793 8.48175C78.6324 8.47539 78.5848 8.48593 78.5449 8.51151C78.5049 8.53708 78.4753 8.57603 78.4611 8.62149C75.6666 15.5109 73.3089 22.5718 71.4021 29.7617C68.6916 32.0858 65.2574 33.4594 61.6777 32.305C61.6438 32.2949 61.6078 32.2943 61.5736 32.3034C61.5394 32.3125 61.5084 32.3308 61.4838 32.3564C59.9657 34.326 57.3454 35.0967 55.0448 34.4193C55.3459 33.9048 55.5548 33.341 55.6623 32.7538C55.6703 32.7238 55.6715 32.6924 55.6656 32.6619C55.6598 32.6315 55.6471 32.6028 55.6285 32.578C55.61 32.5532 55.5861 32.533 55.5586 32.519C55.5312 32.5049 55.5009 32.4973 55.4701 32.4969C54.4971 32.4677 53.707 32.925 53.2376 33.7813C53.2118 33.8276 53.2049 33.882 53.2182 33.9333C53.2315 33.9846 53.2641 34.0286 53.309 34.0562C53.6613 34.288 54.0367 34.482 54.4291 34.6351C53.4196 36.0489 51.7076 36.9421 49.9216 36.6766C47.4016 36.3007 45.6692 33.7445 45.9549 31.2595C45.9796 31.0522 45.6768 31.0026 45.5833 31.1576C44.6294 32.7745 43.3557 34.1768 41.8412 35.2774C41.5894 33.7725 41.338 32.2682 41.0868 30.7645C41.0519 30.5564 40.7568 30.5932 40.7015 30.7645C38.9216 36.3173 35.4207 41.1494 30.7126 44.5514C31.4444 38.9638 32.5373 33.4301 33.9844 27.9857C36.8846 26.1874 39.385 23.6467 40.579 20.3995C42.0886 16.2976 40.9983 11.861 38.8296 8.22159C37.6399 6.25306 36.1896 4.45682 34.5185 2.88236C33.0931 1.52508 31.4032 0.142104 29.3595 0.0102293C25.927 -0.207279 23.8688 3.08531 22.8491 5.93861C22.0888 8.06488 21.7945 10.3059 21.479 12.5324C21.0997 15.211 20.7901 17.899 20.5137 20.5904C20.1114 24.5056 19.7797 28.4276 19.4081 32.3453C18.9137 32.4498 18.4218 32.5557 17.9325 32.663L0.143014 36.5858C-0.0321843 36.6244 -0.044091 36.8667 0.0945371 36.9532C5.68303 40.4556 11.7461 42.7762 17.9546 44.7347C17.6731 46.6032 17.3533 48.4657 16.9748 50.3145C15.4678 52.6706 13.9607 55.0272 12.4537 57.3844C11.3923 59.0457 10.3164 60.7001 9.27036 62.3717C8.40967 63.7469 7.67316 65.1513 7.55494 66.7989C7.55509 66.83 7.56238 66.8607 7.57625 66.8885C7.59012 66.9164 7.61018 66.9406 7.63488 66.9593C7.65958 66.9781 7.68824 66.9908 7.71863 66.9965C7.74902 67.0023 7.78032 67.0009 7.81008 66.9924C11.235 65.6583 13.413 62.6431 14.8197 59.342C16.0223 56.5161 16.7758 53.4881 17.3635 50.4447L18.2837 49.0026L20.5103 45.5182C27.7853 47.6967 35.2023 49.5258 42.2511 52.2832C46.3189 53.8743 50.2532 55.801 53.8975 58.2262C54.1127 58.3692 54.3126 58.0215 54.0991 57.8794C44.0158 51.17 32.1933 48.5873 20.7348 45.1663C23.6831 40.5541 26.6289 35.9422 29.5721 31.3305C29.9203 30.7859 30.2678 30.2416 30.6148 29.6975C31.0937 29.498 31.5682 29.2899 32.036 29.0638C32.5318 28.8241 33.0217 28.562 33.5031 28.282C32.0614 33.7745 30.9778 39.3559 30.2593 44.9907C30.2398 45.1397 30.4439 45.2476 30.5595 45.162C35.3098 41.8469 38.9043 37.1115 40.8342 31.626C41.061 32.9784 41.2878 34.3305 41.5146 35.6824C41.5228 35.7121 41.5376 35.7395 41.558 35.7625C41.5783 35.7855 41.6036 35.8034 41.632 35.815C41.6603 35.8266 41.6909 35.8315 41.7215 35.8293C41.752 35.8271 41.7816 35.8178 41.808 35.8023C43.2796 34.7811 44.5452 33.4876 45.5373 31.9908C45.6139 34.4159 47.4203 36.7177 49.8748 37.0799C51.8309 37.3685 53.7419 36.3581 54.828 34.773C55.6578 35.0304 56.5301 35.1195 57.3944 35.035C58.2587 34.9504 59.0977 34.694 59.8628 34.2806C60.3766 34.0044 60.8473 33.6538 61.2601 33.2401C61.5204 32.9764 61.5961 32.7871 61.9967 32.8223C62.3632 32.8557 62.7468 33.0072 63.1159 33.0603C64.3016 33.2245 65.5078 33.1488 66.6641 32.8377C68.3548 32.3915 69.8695 31.578 71.209 30.517C69.7627 36.07 68.5899 41.687 67.6906 47.3679C67.1106 51.0267 66.6476 54.7035 66.3018 58.3983C66.2771 58.6552 66.6768 58.6552 66.7007 58.3983C67.6048 48.8353 69.2876 39.3633 71.7321 30.0777C74.5957 27.5849 76.5892 23.9481 77.6803 20.4294C78.8477 16.6295 79.2465 12.6324 78.8531 8.67458ZM21.5224 15.2529C22.0369 11.1545 22.3303 6.4584 24.7814 2.96543C25.8521 1.43945 27.4332 0.285112 29.3655 0.415274C31.8021 0.580546 33.799 2.62461 35.3767 4.31672C38.4707 7.63329 41.0323 12.0151 40.8963 16.7035C40.7636 21.2575 37.8167 25.0339 34.1409 27.4231C34.692 25.3862 35.2913 23.3621 35.9388 21.3508C36.0111 21.1273 35.693 21.0083 35.574 21.1959L30.335 29.3927C26.9875 30.7713 23.3568 31.5155 19.818 32.2622C20.3632 26.5907 20.8131 20.9073 21.5224 15.2529ZM12.0948 42.313C8.15283 40.8367 4.32227 39.0692 0.728994 36.8676L17.0735 33.271C17.8338 33.0997 18.6044 32.9421 19.3698 32.7812C19.2326 34.2015 19.0872 35.6216 18.9335 37.0414C18.6673 39.4691 18.3713 41.9071 18.0141 44.3356C16.0257 43.7054 14.0441 43.0417 12.0948 42.3121V42.313ZM15.848 55.0826C14.6301 59.5715 12.5124 64.5407 7.99804 66.4718C8.20385 64.8653 9.03988 63.4798 9.89801 62.1293C10.8279 60.6696 11.7597 59.2109 12.6935 57.7535L16.7316 51.432C16.4637 52.6566 16.1754 53.8743 15.848 55.0826ZM17.5566 49.394C17.7505 48.3278 17.9291 47.2617 18.1026 46.205C18.1766 45.7537 18.2455 45.3007 18.3152 44.8486C18.9122 45.0341 19.5101 45.2174 20.1089 45.3983L17.5566 49.394ZM20.3334 45.0472C19.6802 44.8514 19.0282 44.6516 18.3773 44.4478C18.9667 40.5438 19.3979 36.6209 19.7738 32.6921C23.2174 31.9711 26.7018 31.2321 29.971 29.9518L20.3334 45.0472ZM30.9814 29.1195L35.1096 22.6568C34.5863 24.3403 34.097 26.033 33.6417 27.7348C32.7865 28.2531 31.899 28.7153 30.9848 29.1186L30.9814 29.1195ZM53.6892 33.8147C53.8544 33.5521 54.0795 33.333 54.3458 33.1756C54.6121 33.0182 54.9118 32.927 55.22 32.9096C55.1048 33.3944 54.9163 33.8585 54.6613 34.2857C54.3234 34.1598 53.9982 34.0018 53.69 33.8139L53.6892 33.8147ZM74.747 25.9237C73.9468 27.1505 73.0047 28.2773 71.9405 29.2805C72.8425 25.9168 73.8441 22.5814 74.9452 19.2742C76.0401 15.9945 77.2321 12.751 78.5215 9.54376C78.9118 15.1459 77.836 21.1984 74.7479 25.9228L74.747 25.9237Z"
                  fill="#1F1E21"
                />
              </svg>
            </div>
          </div>
        </div>
        <div class="contract_card ">
          <div class="contract_header d-flex ">
            <h3>Annuel Contract</h3>
            <div class="type_badge accepted">
              Accepted
            </div>
          </div>
          <div class="contract_body">
            <div class="num_contract d-flex">
              <h4>N°110 645 673 11012</h4>
              <svg
                width="25"
                height="28"
                viewBox="0 0 27 27"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M4.52051 8.11747C5.19023 7.42945 6.15185 7.10742 7.42591 7.10742H13.7959C15.071 7.10742 16.0291 7.42995 16.6983 8.11746C17.3327 8.76913 17.5727 9.62185 17.7278 10.3356L17.7292 10.3419L17.7292 10.342L18.7566 15.2373C18.8127 15.5046 18.7453 15.7829 18.5732 15.9949C18.401 16.2069 18.1425 16.3301 17.8694 16.3301H3.36457C3.09146 16.3301 2.83292 16.2069 2.66078 15.9949C2.48864 15.7829 2.42125 15.5046 2.47735 15.2373L3.50391 10.3461C3.64844 9.62473 3.88427 8.77109 4.52051 8.11747ZM5.81972 9.38213C5.57183 9.6368 5.4145 10.0382 5.28094 10.7059L5.27926 10.7144L5.27922 10.7144L4.48113 14.517H16.7528L15.9554 10.7176C15.8086 10.0432 15.6498 9.63966 15.3991 9.38213C15.183 9.16006 14.7692 8.92052 13.7959 8.92052H7.42591C6.45173 8.92052 6.0354 9.16056 5.81972 9.38213Z"
                  fill="#483A9D"
                />
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M2.93762 17.9738L2.42933 23.5045C2.37779 24.0084 2.78813 24.4881 3.3647 24.4881H5.06902C5.26016 24.4881 5.35881 24.468 5.40226 24.4548C5.40338 24.4525 5.40457 24.45 5.40582 24.4473C5.43056 24.3939 5.45426 24.3248 5.50036 24.1832L5.50233 24.1772L5.68518 23.6287C5.6907 23.6124 5.69643 23.5954 5.70238 23.5777C5.80385 23.2755 5.97367 22.7698 6.38241 22.3842C6.85635 21.9371 7.49738 21.7684 8.27217 21.7684H12.9137C13.6643 21.7684 14.3069 21.9112 14.7874 22.355C15.1963 22.7327 15.3696 23.2431 15.4777 23.5615C15.4852 23.5836 15.4924 23.6048 15.4994 23.6249L15.5022 23.6333L15.6805 24.168C15.7296 24.3057 15.7542 24.3739 15.7818 24.4314C15.7863 24.4407 15.7901 24.4481 15.7932 24.4539C15.8328 24.467 15.9274 24.4881 16.1168 24.4881H17.8212C18.3869 24.4881 18.8023 24.0166 18.7557 23.4957C18.7557 23.4952 18.7557 23.4948 18.7556 23.4943L18.2364 17.9762C18.2363 17.9756 18.2363 17.9751 18.2362 17.9746C18.1673 17.2678 18.0775 16.9269 17.9042 16.721C17.7756 16.5682 17.4421 16.317 16.3707 16.317H4.8031C3.73173 16.317 3.3982 16.5682 3.26956 16.721C3.09632 16.9268 3.0065 17.2676 2.93762 17.9738ZM15.7696 24.4435C15.7699 24.4433 15.773 24.4447 15.7783 24.4483C15.7719 24.4455 15.7693 24.4437 15.7696 24.4435ZM1.88246 15.5534C2.50928 14.8087 3.49326 14.5039 4.8031 14.5039H16.3707C17.6805 14.5039 18.6645 14.8087 19.2913 15.5534C19.8733 16.2448 19.9769 17.1425 20.041 17.8005L20.0412 17.8034L20.5613 23.3302C20.7073 24.9361 19.4306 26.3012 17.8212 26.3012H16.1168C15.5064 26.3012 14.96 26.1693 14.5469 25.7771C14.2093 25.4566 14.0628 25.0358 13.9875 24.8194C13.9811 24.801 13.9752 24.784 13.9698 24.7688L13.9635 24.7506L13.7836 24.2109C13.7164 24.0159 13.6753 23.8991 13.6299 23.8038C13.5895 23.7187 13.5646 23.6938 13.5572 23.6869C13.5532 23.6831 13.5291 23.6605 13.4458 23.6363C13.3505 23.6086 13.1864 23.5815 12.9137 23.5815H8.27217C7.75155 23.5815 7.63739 23.6926 7.62709 23.7026C7.6269 23.7028 7.62722 23.7025 7.62709 23.7026C7.57943 23.7476 7.53245 23.8275 7.40293 24.209L7.22344 24.7474C7.21929 24.7602 7.2149 24.7739 7.21023 24.7885C7.13781 25.0152 6.99815 25.4523 6.64507 25.7844C6.22748 26.1773 5.67454 26.3012 5.06902 26.3012H3.3647C1.76722 26.3012 0.462289 24.9463 0.625077 23.3251L1.13281 17.8005C1.19686 17.1425 1.30043 16.2448 1.88246 15.5534Z"
                  fill="#483A9D"
                />
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M1.53906 12.7034C1.53906 12.2028 1.94494 11.7969 2.44561 11.7969H3.35216C3.85284 11.7969 4.25871 12.2028 4.25871 12.7034C4.25871 13.2041 3.85284 13.61 3.35216 13.61H2.44561C1.94494 13.61 1.53906 13.2041 1.53906 12.7034Z"
                  fill="#483A9D"
                />
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M16.9512 12.7034C16.9512 12.2028 17.357 11.7969 17.8577 11.7969H18.7643C19.2649 11.7969 19.6708 12.2028 19.6708 12.7034C19.6708 13.2041 19.2649 13.61 18.7643 13.61H17.8577C17.357 13.61 16.9512 13.2041 16.9512 12.7034Z"
                  fill="#483A9D"
                />
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M4.25977 19.0501C4.25977 18.5494 4.66564 18.1436 5.16632 18.1436H7.88597C8.38664 18.1436 8.79252 18.5494 8.79252 19.0501C8.79252 19.5508 8.38664 19.9567 7.88597 19.9567H5.16632C4.66564 19.9567 4.25977 19.5508 4.25977 19.0501Z"
                  fill="#483A9D"
                />
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M12.418 19.0501C12.418 18.5494 12.8238 18.1436 13.3245 18.1436H16.0442C16.5448 18.1436 16.9507 18.5494 16.9507 19.0501C16.9507 19.5508 16.5448 19.9567 16.0442 19.9567H13.3245C12.8238 19.9567 12.418 19.5508 12.418 19.0501Z"
                  fill="#483A9D"
                />
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M22.0805 6.08335C21.3265 4.94708 20.1176 4.22529 18.8967 4.24249C18.3961 4.24954 17.996 4.66109 18.003 5.16172C18.0101 5.66234 18.4216 6.06246 18.9222 6.05541C19.4166 6.04845 20.0921 6.36472 20.5711 7.08794L20.5711 7.08796L20.5757 7.0947C21.0665 7.82156 21.0986 8.56004 20.9053 9.00876C20.7073 9.46859 20.9195 10.0019 21.3793 10.2C21.8391 10.3981 22.3724 10.1859 22.5705 9.72607C23.0536 8.60455 22.8449 7.21733 22.0805 6.08335Z"
                  fill="#483A9D"
                />
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M18.3358 1.11149C18.3964 0.614491 18.8483 0.260663 19.3453 0.321195C21.5193 0.585969 23.6775 1.9349 25.1022 4.06536C26.5254 6.1935 26.9567 8.69972 26.3704 10.8075C26.2362 11.2899 25.7364 11.5721 25.2541 11.438C24.7717 11.3038 24.4894 10.804 24.6236 10.3216C25.0527 8.77906 24.7586 6.81306 23.5951 5.07326C22.4332 3.33577 20.7235 2.31554 19.1261 2.12099C18.6291 2.06046 18.2753 1.60849 18.3358 1.11149Z"
                  fill="#483A9D"
                />
              </svg>
            </div>
            <div class="police_number d-flex">
              <h4>Police number :</h4>
              <p>76565871</p>
            </div>

            <div class="date_block">
              <h3>Dates :</h3>
              <div class="dates d-flex">
                <div class="date_debut">
                  <svg
                    width="15"
                    height="16"
                    viewBox="0 0 15 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M4.5112 3.38166C4.21253 3.38166 3.96484 3.13398 3.96484 2.83531V0.649874C3.96484 0.351198 4.21253 0.103516 4.5112 0.103516C4.80988 0.103516 5.05756 0.351198 5.05756 0.649874V2.83531C5.05756 3.13398 4.80988 3.38166 4.5112 3.38166Z"
                      fill="#483A9D"
                    />
                    <path
                      d="M10.3384 3.38166C10.0397 3.38166 9.79199 3.13398 9.79199 2.83531V0.649874C9.79199 0.351198 10.0397 0.103516 10.3384 0.103516C10.637 0.103516 10.8847 0.351198 10.8847 0.649874V2.83531C10.8847 3.13398 10.637 3.38166 10.3384 3.38166Z"
                      fill="#483A9D"
                    />
                    <path
                      d="M13.617 6.36127H1.23288C0.934206 6.36127 0.686523 6.11359 0.686523 5.81491C0.686523 5.51624 0.934206 5.26855 1.23288 5.26855H13.617C13.9157 5.26855 14.1634 5.51624 14.1634 5.81491C14.1634 6.11359 13.9157 6.36127 13.617 6.36127Z"
                      fill="#483A9D"
                    />
                    <path
                      d="M10.3388 15.7658H4.51101C1.85207 15.7658 0.322266 14.236 0.322266 11.5771V5.38504C0.322266 2.72609 1.85207 1.19629 4.51101 1.19629H10.3388C12.9978 1.19629 14.5276 2.72609 14.5276 5.38504V11.5771C14.5276 14.236 12.9978 15.7658 10.3388 15.7658ZM4.51101 2.28901C2.42757 2.28901 1.41498 3.30159 1.41498 5.38504V11.5771C1.41498 13.6605 2.42757 14.6731 4.51101 14.6731H10.3388C12.4223 14.6731 13.4349 13.6605 13.4349 11.5771V5.38504C13.4349 3.30159 12.4223 2.28901 10.3388 2.28901H4.51101Z"
                      fill="#483A9D"
                    />
                    <path
                      d="M4.87496 9.75579C4.78026 9.75579 4.68555 9.73395 4.59814 9.69752C4.51072 9.6611 4.4306 9.61009 4.35775 9.54453C4.29219 9.47168 4.24118 9.39156 4.20475 9.30414C4.16833 9.21672 4.14648 9.12202 4.14648 9.02731C4.14648 8.83791 4.22662 8.64851 4.35775 8.5101C4.4306 8.44454 4.51072 8.39353 4.59814 8.35711C4.72926 8.29883 4.87497 8.28426 5.02067 8.3134C5.06438 8.32068 5.10808 8.33525 5.15179 8.35711C5.1955 8.37167 5.2392 8.39355 5.28291 8.42269C5.31933 8.45183 5.35575 8.48096 5.39217 8.5101C5.42131 8.54653 5.45773 8.58294 5.47959 8.61937C5.50873 8.66308 5.5306 8.70678 5.54517 8.75049C5.56703 8.7942 5.58159 8.8379 5.58888 8.88161C5.59616 8.9326 5.60344 8.97632 5.60344 9.02731C5.60344 9.21672 5.5233 9.40612 5.39217 9.54453C5.25376 9.67565 5.06437 9.75579 4.87496 9.75579Z"
                      fill="#483A9D"
                    />
                    <path
                      d="M7.42477 9.75596C7.23536 9.75596 7.04596 9.67582 6.90755 9.54469C6.87841 9.50827 6.84928 9.47185 6.82014 9.43542C6.791 9.39172 6.76913 9.34801 6.75456 9.3043C6.7327 9.26059 6.71814 9.21689 6.71085 9.17318C6.70357 9.12219 6.69629 9.07847 6.69629 9.02748C6.69629 8.93278 6.71813 8.83807 6.75456 8.75065C6.79098 8.66324 6.84199 8.58311 6.90755 8.51027C7.11153 8.30629 7.43934 8.24071 7.70159 8.35727C7.79629 8.39369 7.86913 8.4447 7.94198 8.51027C8.07311 8.64868 8.15324 8.83807 8.15324 9.02748C8.15324 9.07847 8.14597 9.12219 8.13868 9.17318C8.1314 9.21689 8.11683 9.26059 8.09498 9.3043C8.08041 9.34801 8.05853 9.39172 8.02939 9.43542C8.00025 9.47185 7.97112 9.50827 7.94198 9.54469C7.86913 9.61025 7.79629 9.66126 7.70159 9.69769C7.61417 9.73411 7.51947 9.75596 7.42477 9.75596Z"
                      fill="#483A9D"
                    />
                    <path
                      d="M4.87496 12.3058C4.78026 12.3058 4.68555 12.2839 4.59814 12.2475C4.51072 12.2111 4.4306 12.1601 4.35775 12.0945C4.29219 12.0216 4.24118 11.9488 4.20475 11.8541C4.16833 11.7667 4.14648 11.672 4.14648 11.5773C4.14648 11.3879 4.22662 11.1985 4.35775 11.0601C4.4306 10.9945 4.51072 10.9435 4.59814 10.9071C4.86767 10.7905 5.1882 10.8561 5.39217 11.0601C5.42131 11.0965 5.45773 11.1329 5.47959 11.1693C5.50873 11.213 5.5306 11.2567 5.54517 11.3005C5.56703 11.3442 5.58159 11.3879 5.58888 11.4389C5.59616 11.4826 5.60344 11.5336 5.60344 11.5773C5.60344 11.7667 5.5233 11.9561 5.39217 12.0945C5.25376 12.2256 5.06437 12.3058 4.87496 12.3058Z"
                      fill="#483A9D"
                    />
                  </svg>
                  <span>01/01/2023</span>
                </div>
                <div class="date_fin">
                  <svg
                    width="15"
                    height="16"
                    viewBox="0 0 15 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M4.5112 3.38166C4.21253 3.38166 3.96484 3.13398 3.96484 2.83531V0.649874C3.96484 0.351198 4.21253 0.103516 4.5112 0.103516C4.80988 0.103516 5.05756 0.351198 5.05756 0.649874V2.83531C5.05756 3.13398 4.80988 3.38166 4.5112 3.38166Z"
                      fill="#483A9D"
                    />
                    <path
                      d="M10.3384 3.38166C10.0397 3.38166 9.79199 3.13398 9.79199 2.83531V0.649874C9.79199 0.351198 10.0397 0.103516 10.3384 0.103516C10.637 0.103516 10.8847 0.351198 10.8847 0.649874V2.83531C10.8847 3.13398 10.637 3.38166 10.3384 3.38166Z"
                      fill="#483A9D"
                    />
                    <path
                      d="M13.617 6.36127H1.23288C0.934206 6.36127 0.686523 6.11359 0.686523 5.81491C0.686523 5.51624 0.934206 5.26855 1.23288 5.26855H13.617C13.9157 5.26855 14.1634 5.51624 14.1634 5.81491C14.1634 6.11359 13.9157 6.36127 13.617 6.36127Z"
                      fill="#483A9D"
                    />
                    <path
                      d="M10.3388 15.7658H4.51101C1.85207 15.7658 0.322266 14.236 0.322266 11.5771V5.38504C0.322266 2.72609 1.85207 1.19629 4.51101 1.19629H10.3388C12.9978 1.19629 14.5276 2.72609 14.5276 5.38504V11.5771C14.5276 14.236 12.9978 15.7658 10.3388 15.7658ZM4.51101 2.28901C2.42757 2.28901 1.41498 3.30159 1.41498 5.38504V11.5771C1.41498 13.6605 2.42757 14.6731 4.51101 14.6731H10.3388C12.4223 14.6731 13.4349 13.6605 13.4349 11.5771V5.38504C13.4349 3.30159 12.4223 2.28901 10.3388 2.28901H4.51101Z"
                      fill="#483A9D"
                    />
                    <path
                      d="M4.87496 9.75579C4.78026 9.75579 4.68555 9.73395 4.59814 9.69752C4.51072 9.6611 4.4306 9.61009 4.35775 9.54453C4.29219 9.47168 4.24118 9.39156 4.20475 9.30414C4.16833 9.21672 4.14648 9.12202 4.14648 9.02731C4.14648 8.83791 4.22662 8.64851 4.35775 8.5101C4.4306 8.44454 4.51072 8.39353 4.59814 8.35711C4.72926 8.29883 4.87497 8.28426 5.02067 8.3134C5.06438 8.32068 5.10808 8.33525 5.15179 8.35711C5.1955 8.37167 5.2392 8.39355 5.28291 8.42269C5.31933 8.45183 5.35575 8.48096 5.39217 8.5101C5.42131 8.54653 5.45773 8.58294 5.47959 8.61937C5.50873 8.66308 5.5306 8.70678 5.54517 8.75049C5.56703 8.7942 5.58159 8.8379 5.58888 8.88161C5.59616 8.9326 5.60344 8.97632 5.60344 9.02731C5.60344 9.21672 5.5233 9.40612 5.39217 9.54453C5.25376 9.67565 5.06437 9.75579 4.87496 9.75579Z"
                      fill="#483A9D"
                    />
                    <path
                      d="M7.42477 9.75596C7.23536 9.75596 7.04596 9.67582 6.90755 9.54469C6.87841 9.50827 6.84928 9.47185 6.82014 9.43542C6.791 9.39172 6.76913 9.34801 6.75456 9.3043C6.7327 9.26059 6.71814 9.21689 6.71085 9.17318C6.70357 9.12219 6.69629 9.07847 6.69629 9.02748C6.69629 8.93278 6.71813 8.83807 6.75456 8.75065C6.79098 8.66324 6.84199 8.58311 6.90755 8.51027C7.11153 8.30629 7.43934 8.24071 7.70159 8.35727C7.79629 8.39369 7.86913 8.4447 7.94198 8.51027C8.07311 8.64868 8.15324 8.83807 8.15324 9.02748C8.15324 9.07847 8.14597 9.12219 8.13868 9.17318C8.1314 9.21689 8.11683 9.26059 8.09498 9.3043C8.08041 9.34801 8.05853 9.39172 8.02939 9.43542C8.00025 9.47185 7.97112 9.50827 7.94198 9.54469C7.86913 9.61025 7.79629 9.66126 7.70159 9.69769C7.61417 9.73411 7.51947 9.75596 7.42477 9.75596Z"
                      fill="#483A9D"
                    />
                    <path
                      d="M4.87496 12.3058C4.78026 12.3058 4.68555 12.2839 4.59814 12.2475C4.51072 12.2111 4.4306 12.1601 4.35775 12.0945C4.29219 12.0216 4.24118 11.9488 4.20475 11.8541C4.16833 11.7667 4.14648 11.672 4.14648 11.5773C4.14648 11.3879 4.22662 11.1985 4.35775 11.0601C4.4306 10.9945 4.51072 10.9435 4.59814 10.9071C4.86767 10.7905 5.1882 10.8561 5.39217 11.0601C5.42131 11.0965 5.45773 11.1329 5.47959 11.1693C5.50873 11.213 5.5306 11.2567 5.54517 11.3005C5.56703 11.3442 5.58159 11.3879 5.58888 11.4389C5.59616 11.4826 5.60344 11.5336 5.60344 11.5773C5.60344 11.7667 5.5233 11.9561 5.39217 12.0945C5.25376 12.2256 5.06437 12.3058 4.87496 12.3058Z"
                      fill="#483A9D"
                    />
                  </svg>
                  <span>01/01/2023</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </slide>
    </carousel>
  </div>
</template>

<script>
import { Carousel, Slide } from 'vue-carousel';
export default {
  name: 'ClientInformations',
  components: {
    Carousel,
    Slide,
  },
};
</script>

<style lang="scss" scoped>
.infos_assur {
  padding: 6px 8px;
}

.ongoing_contracts {
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 19px;
  color: #483a9d;
}

.annuel_contracts {
  background-position: top right 10px !important;
  background-repeat: no-repeat !important;
  background: #ffffff;
  border-radius: 8px;
  box-shadow: 0 0 10px rgba(0, 68, 140, 0.1);
  padding: 10px;
  padding-bottom: 4rem;
  padding-top: 15px;

  h4 {
    font-style: normal;
    font-weight: 600;
    font-size: 16px;
    line-height: 19px;
    text-transform: capitalize;
    color: #483a9d;
  }

  .sub_contracts {
    background: #483a9d33;
    box-shadow: 0 0 10px rgba(0, 78, 159, 0.05);
    border-radius: 10px;
    font-style: normal;
    font-weight: 500;
    font-size: 20px;
    line-height: 24px;
    letter-spacing: 0.1em;
    text-align: center;
    color: #483a9d;
    height: 38px;
    padding-top: 8px;
    margin-bottom: 15px;
    margin-top: 13px;
  }

  .num_police {
    display: flex;
    justify-content: space-between;

    p {
      font-style: normal;
      font-weight: 600;
      font-size: 16px;
      line-height: 19px;
      color: #483a9d;
    }
  }

  .dates {
    display: flex;
    justify-content: space-between;
    padding: 5px 10px;

    .start_date {
      span {
        margin-left: 5px;
        font-style: normal;
        font-weight: 400;
        font-size: 13px;
        line-height: 14px;
        color: #49cf48;
        margin-top: 4px;
      }

      svg {
        opacity: 0.8;
        margin-right: 2px;
      }
    }

    .end_date {
      span {
        margin-left: 5px;
        font-style: normal;
        font-weight: 400;
        font-size: 13px;
        line-height: 14px;
        color: #fa3559;
        margin-top: 4px;
      }

      svg {
        opacity: 0.8;
        margin-right: 2px;
      }
    }
  }

  .subtitle {
    font-style: normal !important;
    font-weight: 600 !important;
    font-size: 16px !important;
    line-height: 19px !important;
    color: #483a9d !important;
  }

  .subtitle_info {
    font-style: normal;
    font-weight: 600;
    font-size: 14px;
    line-height: 17px;
    color: #656877;
  }

  .assured_risks {
    margin-left: 8px !important;
  }

  .info_insurance {
    font-style: normal;
    font-weight: 500;
    font-size: 12px;
    line-height: 15px;
    color: #a49dcf;
  }

  .success_insurance {
    font-style: normal;
    font-weight: 600;
    font-size: 14px;
    line-height: 17px;
    color: #49cf48;
  }

  .car_identification {
    background: #f9f9f9;
    border-radius: 8px;
    margin-top: 8px;
    padding: 8px 6px;
  }

  .car {
    justify-content: space-between;
    background: #ffffff;
    border-radius: 8px;
    margin-top: 2px;
    margin-bottom: 2px;
    padding: 9px 12px;
    height: 34px;
    margin-top: 8px;
  }

  .coverage {
    justify-content: space-between;
    padding: 4px 6px;
  }

  .prime {
    justify-content: space-between;
    padding: 4px 6px;
  }

  .signature_insurance {
    display: flex;
    justify-content: space-between;
    padding-left: 8px;

    svg {
      margin-right: 4rem;
      margin-top: 3rem;
    }
  }
}

.contract_card {
  background: linear-gradient(
    181.71deg,
    #483a9d -22.79%,
    #a49dcf 237.25%,
    #a49dcf 237.27%
  );
  box-shadow: 0px 5px 20px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  padding: 12px;
  margin: -24px 18px 5px 18px;

  .contract_header {
    justify-content: space-between;
    margin-bottom: 12px;

    h3 {
      font-style: normal;
      font-weight: 500;
      font-size: 16.1259px;
      line-height: 20px;
      color: #ffffff;
      margin-top: 3px !important;
    }

    .type_badge {
      padding: 6px 10px;
      font-style: normal;
      font-weight: 500;
      font-size: 12.4327px;
      line-height: 15px;
    }

    .accepted {
      color: #49cf48 !important;
      background: #f4fbf5 !important;
      border: 1px solid #49cf48 !important;
      border-radius: 5px !important;
    }

    .pending {
      color: #f8ab26 !important;
      background: #fffbf4 !important;
      border: 1px solid #f8ab26 !important;
      border-radius: 5px !important;
    }
  }

  .contract_body {
    background: #ffff;
    box-shadow: 0px 3.45556px 11.5185px rgba(0, 0, 0, 0.05);
    border-radius: 5.75926px;
    padding: 10px 8px;

    .num_contract {
      justify-content: space-between;
      padding: 0 0 5px 0;
      border-bottom: 1px solid #a49dcf;

      h4 {
        font-style: normal !important;
        font-weight: 500 !important;
        font-size: 14.9246px !important;
        line-height: 18px !important;
        letter-spacing: 0.1em !important;
        margin-top: 4px;
      }

      svg {
        opacity: 0.6;
        margin-top: -5px;
      }
    }

    .police_number {
      justify-content: space-between;
      margin-top: 15px;

      h4 {
        font-style: normal !important;
        font-weight: 500 !important;
        font-size: 13.4687px !important;
        line-height: 16px !important;
        color: #483a9d !important;
      }

      p {
        font-style: normal;
        font-weight: 400;
        font-size: 14px;
        line-height: 18px;
        color: #656877;
      }
    }

    .date_block {
      h3 {
        font-style: normal !important;
        font-weight: 500 !important;
        font-size: 13.4687px !important;
        line-height: 16px !important;
        color: #483a9d !important;
      }

      .dates {
        justify-content: space-between;
        margin-top: 2px;

        .date_debut {
          display: flex;

          span {
            margin-left: 5px;
            font-style: normal;
            font-weight: 400;
            font-size: 13px;
            line-height: 14px;
            color: #656877;
            margin-top: 2px;
          }

          svg {
            opacity: 0.6;
          }
        }

        .date_fin {
          display: flex;

          span {
            margin-left: 5px;
            font-style: normal;
            font-weight: 400;
            font-size: 13px;
            line-height: 14px;
            color: #656877;
            margin-top: 2px;
          }

          svg {
            opacity: 0.6;
          }
        }
      }
    }
  }
}

::v-deep .VueCarousel-navigation-button:focus {
  outline: none !important;
}

.VueCarousel-navigation-button:focus {
  outline: none !important;
}
::v-deep .VueCarousel-dot {
  margin-right: -8px;
  outline: none !important;
}

.VueCarousel-dot {
  margin-right: -8px;
  outline: none !important;
}

.VueCarousel-dot-container {
  margin-top: 0px !important;
}

::v-deep .VueCarousel-dot-container {
  margin-top: 0px !important;
}
</style>
